import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Slide from '@material-ui/core/Slide';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';

import DocumentContainer from '../../containers/accounting/Document';
import StationInvoiceContainer from '../../containers/accounting/StationInvoice';
import CarriersContainer from '../../containers/logistics/Carriers';
import TerminalsContainer from '../../containers/logistics/Terminals';
import StationsContainer from '../../containers/Stations';
//import SaveInvoiceDocumentsDialog from '../../components/Dialogs/SaveInvoiceDocuments';
import ConfirmInvalidateStationInvoiceDialog from '../../components/Dialogs/ConfirmInvalidateStationInvoiceDialog';
import SaveInvoiceDocumentsDialog from '../../components/InvoiceDocument/SaveDialog';
import Note from '../../components/ui/Note';
import QuickbooksContainer from '../../containers/accounting/Quickbooks';

import { formatStatus, statusClassNames } from '../../libs/utility';
import {
	documentTypeSort,
	getDocuments,
	invoiceStatusClassNames,
	matchProductToDelivery,
	NET_GALLONS_DELIVERY_MATCH_THRESHOLD,
	statusToDisplay,
} from './general';

//- UI
import CheckIcon from '@material-ui/icons/CheckCircle';
import InfoIcon from '@material-ui/icons/Info';
import ManualPriceNotice, { formatPricePerGallon } from '../../components/ManualPriceNotice';
import WarningIcon from '@material-ui/icons/Warning';
import InvoiceDocumentPopup from '../../components/Dialogs/InvoiceDocumentPopup';
import FMPSelect from '../../components/form/FMPSelect';
import FMPHeadline from '../../components/ui/FMPHeadline';
import FMPRegionHeader from '../../components/ui/FMPRegionHeader';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';
import InvoiceDocumentIcon from '../../components/ui/invoiceDocumentIcon';
import attachIcon from '../../images/attachDocument.svg';
import documentIcon from '../../images/document.svg';
import noDeliveryIcon from '../../images/noDelivery.svg';

import Formula from '../../components/ui/Formula';
import { calcGasFormula } from '../../libs/formulas';

//- Form
import FMPSubmitButton from '../../components/form/FMPSubmitButton';
import ResourceUploader from '../../components/form/ResourceUploader';
import StationSelect from '../../components/form/StationSelect';
//import TerminalSupplierSelect from "../../components/form/TerminalSupplierSelect";
import InvoiceSendConfirmationDialog from '../../components/Dialogs/InvoiceSendConfirmationDialog';
import CreditRebillDialog from '../../components/Dialogs/CreditRebillDialog';
import InvoiceCreditMemoContainer from '../../containers/accounting/InvoiceCreditMemo';
import AuthUserContainer from '../../containers/AuthUser';
import FMPText from '../../components/form/FMPText';

//- Pure form
import FMPCarrierSelect from '../../components/pureForm/FMPCarrierSelect';
import FMPDatePicker from '../../components/pureForm/FMPDatePicker';
import FMPStationQuotedPriceSelect from '../../components/pureForm/FMPStationQuotedPriceSelect';
import DataDumpContainer from '../../containers/accounting/DataDump';
import StationQuotedPriceContainer from '../../containers/accounting/StationQuotedPrices';

import GenericSavingDialog from '../../components/Dialogs/GenericSavingDialog';
import FMPTerminalSupplierSelect from '../../components/pureForm/FMPTerminalSupplierSelect';

import { green } from '@material-ui/core/colors';
import orange from '@material-ui/core/colors/orange';

import InvoicePdfPopup from '../../components/Dialogs/InvoicePdfPopup';
import invoiceIcon from '../../images/invoicePdf.svg';
import quickbooksLogo from '../../images/quickbooksLogo.svg';
import { valueToDisplay } from '../../libs/products';
import { getLegs as getDeliveryLegs, fuelToPickupField } from '../../libs/deliveryLegs';

const SlideUpTransition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const DEFAULT_TERMINAL_SUPPLIER_VALUE = { terminalId: '', supplierId: '' };

//- Manual pricing sanity limits (mirrors libs/accounting/stationInvoiceManualPrice.js)
const MANUAL_PRICE_MIN_EXCLUSIVE = 0;
const MANUAL_PRICE_MAX = 10;
const MANUAL_PRICE_REASON_MAX_LENGTH = 1024;
//- Statuses where the manual price can still be set / changed / removed (not issued)
const MANUAL_PRICE_EDITABLE_STATUSES = ['pending', 'invalid'];

/*
const GALLONS_FOR_HALF_LOAD = 3000;
const SPECIAL_GALLONS_FOR_HALF_LOAD = 1500;
const R001_STATION_ID = 17;
const BOYETT_GALLONS_FOR_HALF_LOAD = 1500;
const BOYETT_GAS_FORMULA_ID = 20;
*/

const styles = (theme) => {
	return {
		...statusClassNames,
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 25,
			paddingBottom: 30,
			marginTop: 20,
			[theme.breakpoints.up('md')]: {
				padding: '10px 40px 40px 40px',
			},
		},
		inputGroup: {
			borderLeft: '5px solid #ccc',
			marginTop: 10,
			marginBottom: 20,
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		addInputButton: {
			borderRadius: '100px',
			marginTop: 20,
		},
		inset: {
			paddingLeft: 5,
			lineHeight: 1.3,
		},
		linkedTo: {
			fontSize: 20,
			paddingTop: 10,
		},
		linkedStatus: {
			fontSize: 15,
		},
		documentContainer: {
			display: 'flex',
			justifyContent: 'space-between',
			borderBottom: '1px solid #F1F1F1',
			paddingBottom: 7,
			marginBottom: 7,
			marginLeft: 10,
			marginTop: 10,
		},
		documentInfoContainer: {
			display: 'flex',
			justifyContent: 'flex-start',
		},
		documentInfo: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		documentIcons: {
			whiteSpace: 'nowrap',
		},
		documentName: {
			fontWeight: 900,
		},
		button: {},
		missingDocumentName: {
			fontWeight: 900,
			color: '#777',
		},
		documentDetails: {
			fontWeight: 200,
		},
		documentRequired: {
			fontSize: 14,
			color: '#777',
		},
		missingRequiredDocs: {
			padding: 20,
			fontSize: 20,
			margin: '20px 10px',
			border: '1px solid #ddd',
			backgroundColor: '#f5f5f5',
		},
		documentIcon: {
			marginRight: 12,
			display: 'inline-block',
			width: 34,
			height: 40,
			backgroundImage: `url('${documentIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
		},
		attachIcon: {
			display: 'inline-block',
			width: 21,
			height: 21,
			backgroundImage: `url('${attachIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'absolute',
			bottom: 0,
			right: 0,
			transform: 'translate(30%, 30%)',
		},
		noDelivery: {
			fontSize: 18,
			color: '#666',
			display: 'flex',
			alignItems: 'center',
		},
		noDeliveryIcon: {
			marginRight: 12,
			display: 'inline-block',
			width: 33,
			height: 34.5,
			backgroundImage: `url('${noDeliveryIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
		},
		matchContainer: {
			backgroundColor: '#f7f7f7',
			padding: 15,
			fontSize: 15,
			fontWeight: 400,
			marginBottom: 10,
			marginTop: 5,
		},
		matchRow: {
			display: 'flex',
			marginBottom: 5,
		},
		warningIcon: {
			color: '#FFC107',
			width: 16,
			height: 16,
			paddingRight: 5,
			borderRight: '1px solid #f1f1f1',
			verticalAlign: 'middle',
		},
		checkIcon: {
			color: '#4CAF50',
			width: 16,
			height: 16,
			paddingRight: 5,
			verticalAlign: 'middle',
		},
		topErrors: {
			fontSize: 18,
			padding: 20,
			border: '2px solid #f44336',
			margin: 20,
			backgroundColor: 'white',
		},
		formulaContainer: {
			//border : '1px solid #eee',
			fontSize: 14,
			backgroundColor: '#f7f7f7',
			padding: '10px 15px 15px 15px',
			marginTop: 10,
			marginBottom: 5,
		},
		formulaTitle: {
			fontSize: 14,
			textTransform: 'uppercase',
			fontWeight: 800,
			color: '#333',
			paddingBottom: 25,
			paddingTop: 10,
		},
		formulaRow: {
			display: 'flex',
			flexDirection: 'row',
			paddingBottom: 2,
		},
		formulaRowBreak: {
			display: 'flex',
			flexDirection: 'row',
			paddingBottom: 2,
			paddingTop: 20,
		},
		formulaSubTitle: {
			paddingTop: 20,
			display: 'flex',
			flexDirection: 'row',
			textAlign: 'left',
			borderBottom: '.5px solid #ddd',
			textTransform: 'uppercase',
			paddingBottom: 2,
			marginBottom: 10,
			color: '#555',
		},
		formulaTotal: {
			borderTop: '2px solid #ccc',
			paddingTop: '5px',
			marginTop: '5px',
			display: 'flex',
			flexDirection: 'row',
			fontWeight: '800',
			paddingBottom: '15px',
		},
		formulaSubtotal: {
			marginLeft: '10%',
			marginRight: '10%',
			borderTop: '1px solid #ddd',
			paddingTop: '3px',
			marginTop: '3px',
			paddingBottom: '20px',
			display: 'flex',
			flexDirection: 'row',
			fontWeight: '800',
		},

		formulaLabel: {
			color: '#333',
			flexBasis: '50%',
			textAlign: 'right',
			paddingRight: '8px',
		},
		formulaValue: {
			color: '#666',
			flexBasis: '50%',
			textAlign: 'left',
		},
		formulaNote: {
			color: '#666',
			textAlign: 'left',
		},
		manualPriceList: {
			margin: '5px 0',
			paddingLeft: 20,
		},
		manualPriceCompare: {
			color: '#666',
			fontSize: 13,
			marginTop: 5,
			marginBottom: 15,
		},
		infoBox: {
			fontSize: 14,
			alignItems: 'center',
			display: 'flex',
			backgroundColor: '#f7f7f7',
			padding: '10px 15px 15px 15px',
			marginTop: 10,
			marginBottom: 5,
		},
		infoIcon: {
			color: '#2196F3',
			width: 32,
			height: 32,
			paddingRight: 5,
			verticalAlign: 'middle',
		},

		snackbarSuccess: {
			backgroundColor: green[600],
		},
		snackbarIcon: {
			opacity: 0.9,
			marginRight: theme.spacing(1),
			fontSize: 20,
		},
		snackbarMessage: {
			display: 'flex',
			alignItems: 'center',
		},
		cancelled: {
			color: orange[500],
			fontWeight: 900,
		},

		//
		invoiceDocument: {
			position: 'absolute',
		},
		invoiceDocumentContainer: {
			position: 'relative',
			display: 'flex',
			alignItems: 'center',
		},
		invoiceIcon: {
			display: 'inline-block',
			width: 40,
			height: 48,
			backgroundImage: `url('${invoiceIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		quickbooksIcon: {
			display: 'inline-block',
			width: 40,
			height: 40,
			backgroundImage: `url('${quickbooksLogo}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
	};
};

const moneyFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 2,
});

class SaveStationInvoice extends Component {
	constructor(props) {
		super(props);
		const stationInvoiceId = _.get(this.props, ['match', 'params', 'stationInvoiceId']);

		this.state = {
			dataForFormula: undefined,
			stationQuotedPrices: [],
			isSaveDocumentDialogOpen: false,
			isConfirmInvalidateOpen: false,
			stationInvoiceId: stationInvoiceId ? parseInt(stationInvoiceId, 10) : undefined,
			isUpdate: stationInvoiceId,
			formFieldError: {},
			invoiceDocuments: [],
			isSendConfirmationOpen: false,
			//isSendConfirmationOpen : true,
			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentPoppedUp: undefined,

			//- Default form values
			issueDate: moment().format('YYYY-MM-DD'),
			quickbooksTermId: undefined,
			isSavingOpen: false,
			savingStatus: undefined,
			stationInvoiceForSending: undefined,

			//- input for G&M
			actualTotalFreightCost: undefined,
			actualUnleadedFuelCostPerGallon: undefined,
			fuelCostPerGallon: undefined,

			formulaRows: [],
			isMissingQuotedPrices: false,

			//- Manual pricing (pending invoices only)
			isManualPricingUnlocked: false,
			manualPricePerGallon: undefined,
			manualPriceReason: undefined,
		};
	}

	componentDidMount() {
		const {
			stationInvoice,
			getStationInvoice,
			carriers,
			searchCarriers,
			terminals,
			searchTerminals,
			searchStations,
			stations,
			quickbooksTerms,
			searchQuickbooksTerms,
		} = this.props;

		const { isUpdate, stationInvoiceId } = this.state;

		if (_.isEmpty(carriers)) {
			searchCarriers();
		}
		if (_.isEmpty(terminals)) {
			searchTerminals();
		}
		if (_.isEmpty(stations)) {
			searchStations();
		}
		if (_.isEmpty(quickbooksTerms)) {
			searchQuickbooksTerms();
		}

		if (!isUpdate) {
			return;
		}

		if (!stationInvoice) {
			getStationInvoice({
				params: {
					stationInvoiceIds: [stationInvoiceId],
				},
			});
		} else {
			const newState = this.getStateFromStationInvoice(this.props);
			this.setState(newState);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (_.isUndefined(prevProps.stationInvoice) && !_.isUndefined(this.props.stationInvoice)) {
			const newState = this.getStateFromStationInvoice(this.props);
			this.setState(newState);
		}

		//- Credit & rebill: pull the linked credit memo so the status box and send flow know it
		const creditMemoId = _.get(this.props.stationInvoice, ['creditMemoId']);
		if (
			creditMemoId &&
			!this.state.creditMemo &&
			!this.fetchingCreditMemo &&
			!this.creditMemoFetchFailed
		) {
			this.fetchingCreditMemo = true;
			this.props.getInvoiceCreditMemo({
				params: { invoiceCreditMemoIds: [creditMemoId] },
				callback: (err, r) => {
					this.fetchingCreditMemo = false;
					const creditMemo = _.get(r, ['collections', 'invoiceCreditMemoCollection', 0]);
					if (err || !creditMemo) {
						//- Don't refire on every re-render; Save & Send resets this for a retry
						this.creditMemoFetchFailed = true;
						return;
					}
					this.setState({ creditMemo });
				},
			});
		}

		//- Not G&M	: Switch stations or delivery dates change
		if (
			prevState.stationId !== this.state.stationId ||
			prevState.deliveryDate !== this.state.deliveryDate
		) {
			this.fetchQuotedPrices();
		}

		let prevNetGallons = 0;
		let thisNetGallons = 0;
		if (!_.isEmpty(prevState.products)) {
			prevState.products.forEach(({ netGallons }) => {
				prevNetGallons += parseInt(netGallons, 10);
			});
		}

		if (!_.isEmpty(this.state.products)) {
			this.state.products.forEach(({ netGallons }) => {
				thisNetGallons += parseInt(netGallons, 10);
			});
		}

		if (
			prevState.actualTotalFreightCost !== this.state.actualTotalFreightCost ||
			prevState.actualUnleadedFuelCostPerGallon !== this.state.actualUnleadedFuelCostPerGallon ||
			prevNetGallons !== thisNetGallons ||
			prevState.stationQuotedPriceId !== this.state.stationQuotedPriceId
		) {
			this.calculateWholesaleE85Price();
		}
	}

	_getProductGallons = () => {
		const { products } = this.state;
		let totalGallons = 0;
		let etohGallons = 0;
		let unlGallons = 0;

		products.forEach(({ productType, netGallons }) => {
			if (productType === 'etoh') {
				etohGallons += parseInt(netGallons, 10);
			} else if (productType === 'unl') {
				unlGallons += parseInt(netGallons, 10);
			}
			totalGallons += parseInt(netGallons, 10);
		});
		return { etohGallons, unlGallons, totalGallons };
	};

	/**
	 * Calculates the e85 price
	 */
	calculateWholesaleE85Price = _.debounce(() => {
		//- First figure out who we are calculating it for
		const { stationMap, gasFormulaMap, rackFormulaMap, stationInvoice } = this.props;

		if (!stationInvoice) {
			return;
		}
		if (stationInvoice.productType !== 'e85') {
			return;
		}

		const { stationId, requireUnlPriceOnInvoicing } = this.state;

		if (!stationId) {
			return;
		}

		const station = stationMap[stationId];
		if (!station) {
			return this.setState({
				errors: [`Missing stationId in calculateE85Price ${stationId}`],
			});
		}

		//- I have to calculate the e85 price based on the gas price entered
		const { gasFormulaId, rackFormulaId } = station;
		const gasFormula = gasFormulaMap[gasFormulaId];
		const rackFormula = rackFormulaMap[rackFormulaId];

		if (!gasFormula) {
			return this.setState({
				errors: [`Missing E85 formula ${gasFormulaId} in calculateE85Price`],
			});
		}

		if (!rackFormula) {
			return this.setState({
				errors: [`Missing ethanol rack formula ${rackFormulaId} in calculateE85Price`],
			});
		}

		const gasFormulaKey = gasFormula.formulaKey;
		const rackFormulaKey = rackFormula.formulaKey;

		const isGm = gasFormulaKey === 'g&mE85';
		const isFalcon = gasFormulaKey === 'falconFormula';
		const isHs = gasFormulaKey === 'h&sE85' || gasFormulaKey === 'h&sNew';
		const is29Palms = gasFormulaKey === '29Palms';

		if (isGm) {
			const { hideFormulaReason, data, stationQuotedPrice } = this.getDataAndPricing();
			if (hideFormulaReason) {
				return this.setState({ hideFormulaReason });
			}

			const actualUnleadedFuelCostPerGallon = parseFloat(
				this.state.actualUnleadedFuelCostPerGallon
			);

			const calcGasParams = {
				data,
				formulaKey: gasFormulaKey,
				rackFormulaKey,
				actualUnleadedFuelCostPerGallon,
			};

			// LEGACY
			if (this.state.actualTotalFreightCost) {
				const actualTotalFreightCost = parseFloat(this.state.actualTotalFreightCost);

				const { etohGallons, unlGallons, totalGallons } = this._getProductGallons();
				let freightPerGallon;
				if (actualTotalFreightCost) {
					freightPerGallon = parseFloat(actualTotalFreightCost) / totalGallons;
				}
				calcGasParams.freightPerGallon = freightPerGallon;
				calcGasParams.etohGallons = etohGallons;
				calcGasParams.unlGallons = unlGallons;
			} else {
				const freightPerGallon = stationQuotedPrice.freight;
				calcGasParams.freightPerGallon = freightPerGallon;
			}

			//- Lots of data goes in. Each formula knows what it wants to use
			const { formulaRows, formulaNotes, e85Price } = calcGasFormula(calcGasParams);

			if (!e85Price) {
				return this.setState({
					hideFormulaReason: null,
					formulaRows,
					formulaNotes,
					calculatedWholesaleE85Price: e85Price,

					errors: [`E85 price not returned from ${gasFormula.display} in GM calculateE85Price`],
				});
			}
			this.setState({
				hideFormulaReason: null,
				formulaRows,
				formulaNotes,
				calculatedWholesaleE85Price: e85Price,
			});
		} else if (isFalcon || isHs) {
			//- Falcon freight does not get blended
			//- const actualTotalFreightCost = parseFloat(this.state.actualTotalFreightCost);
			const actualUnleadedFuelCostPerGallon = parseFloat(
				this.state.actualUnleadedFuelCostPerGallon
			);

			//- Collect all the data to pass to the formula
			const { hideFormulaReason, data } = this.getDataAndPricing();

			if (hideFormulaReason) {
				return this.setState({ hideFormulaReason });
			}

			//- Lots of data goes in. Each formula knows what it wants to use
			const { formulaRows, formulaNotes, e85Price } = calcGasFormula({
				data,
				formulaKey: gasFormulaKey,
				rackFormulaKey,
				actualUnleadedFuelCostPerGallon,
			});

			if (!e85Price) {
				return this.setState({
					errors: [`E85 price not returned from ${gasFormula.display} in calculateE85Price`],
				});
			}
			this.setState({
				hideFormulaReason: null,
				formulaRows,
				formulaNotes,
				calculatedWholesaleE85Price: e85Price,
			});
		} else if (is29Palms) {
			//- freight does not get blended
			const actualUnleadedFuelCostPerGallon = parseFloat(
				this.state.actualUnleadedFuelCostPerGallon
			);

			//- Collect all the data to pass to the formula
			const { hideFormulaReason, data } = this.getDataAndPricing();

			if (hideFormulaReason) {
				return this.setState({ hideFormulaReason });
			}

			//- Lots of data goes in. Each formula knows what it wants to use
			const { formulaRows, formulaNotes, e85Price } = calcGasFormula({
				data,
				formulaKey: gasFormulaKey,
				rackFormulaKey,
				actualUnleadedFuelCostPerGallon,
			});

			if (!e85Price) {
				return this.setState({
					errors: [`E85 price not returned from ${gasFormula.display} in calculateE85Price`],
				});
			}
			this.setState({
				hideFormulaReason: null,
				formulaRows,
				formulaNotes,
				calculatedWholesaleE85Price: e85Price,
			});
		} else if (requireUnlPriceOnInvoicing) {
			const actualUnleadedFuelCostPerGallon = parseFloat(
				this.state.actualUnleadedFuelCostPerGallon
			);

			//- Collect all the data to pass to the formula
			const { hideFormulaReason, data, stationQuotedPrice } = this.getDataAndPricing();

			if (hideFormulaReason) {
				return this.setState({ hideFormulaReason });
			}

			const freightPerGallon = stationQuotedPrice.freight;

			//- Lots of data goes in. Each formula knows what it wants to use
			const { notImplemented, formulaRows, formulaNotes, e85Price } = calcGasFormula({
				data,
				formulaKey: gasFormulaKey,
				rackFormulaKey,
				freightPerGallon,
				actualUnleadedFuelCostPerGallon,
			});

			if (notImplemented) {
				return this.setState({
					errors: [
						`${gasFormula.display} formula has not yet been implemented.` +
							` Please contact DWP to get this work scheduled.`,
					],
				});
			}

			if (!e85Price) {
				return this.setState({
					errors: [`E85 price not returned from ${gasFormula.display} in calculateE85Price`],
				});
			}

			this.setState({
				hideFormulaReason: null,
				formulaRows,
				formulaNotes,
				calculatedWholesaleE85Price: e85Price,
			});
		}
	});

	fetchQuotedPrices = () => {
		const { stationInvoice, searchStationQuotedPrices, showErrors, stationMap } = this.props;
		const { stationQuotedPriceId, stationId, deliveryDate } = this.state;

		//const { defaultDate, defaultFreightType, controller, path} = this.props;

		if (!stationId || !deliveryDate) {
			return;
		}

		const afterDateTime = moment(deliveryDate).subtract(3, 'days').format('YYYY-MM-DD HH:mm:ss');
		const beforeDateTime = moment(deliveryDate).add(3, 'days').format('YYYY-MM-DD HH:mm:ss');

		const { productType } = stationInvoice;

		let paramProductType = productType;
		if (productType === 'b99' || productType === 'rd80/b20') {
			paramProductType = 'biodiesel';
		} else if (productType !== 'e85') {
			console.info(`Not fetching quoted prices for product Type : ${productType}`);
			return;
		}

		searchStationQuotedPrices({
			params: {
				stationIds: [stationId],
				afterDateTime,
				beforeDateTime,
				productTypes: [paramProductType],
			},
			callback: (_err, r) => {
				const stationQuotedPrices = _.get(r, ['collections', 'stationQuotedPriceCollection'], []);

				if (_.isEmpty(stationQuotedPrices)) {
					if (stationMap && stationMap[stationId]) {
						const dateCreated = stationMap[stationId].dateCreated;

						if (moment(dateCreated).isBefore(moment(deliveryDate))) {
							showErrors([
								`Quoted pricing for this station on this date is empty. ` +
									`This is because you are attempting to invoice a delivery ` +
									` that has a delivery date BEFORE the station was existed in the FMP. ` +
									`Contact David to try to backfill quoted prices if you need to backfill pricing.`,
								` Station created: ${moment(dateCreated).format(
									'M/D/YY h:mm a'
								)}, delivery date: ${moment(deliveryDate).format('M/D/YY')}`,
							]);
						} else {
							showErrors([
								`Quoted prices is empty. Maybe this delivery was before the station was created?`,
							]);
						}
					} else {
						showErrors([
							`Quoted prices is empty. Maybe this delivery was before the station was created?`,
						]);
					}

					return this.setState({ isMissingQuotedPrices: true });
				}

				const newState = { stationQuotedPrices };

				//- StationInvoice already has a value
				if (stationQuotedPriceId) {
					return this.setState(newState);
				}

				// Everything just defaults to freightFullLoad now
				let deliveryFreightType = 'freightFullLoad';

				/*

				const stationLookup = _.keyBy(
					_.get(r, ['collections', 'stationCollection'], []),
					'stationId'
				);

				//- Figure out some shit and save it
				const linkedStationDeliveryId = stationInvoice.linkedStationDeliveryId;
				if (linkedStationDeliveryId) {
					const stationDelivery = stationDeliveryMap[linkedStationDeliveryId];
					if (stationDelivery) {
						const {
							primaryStationId,
							secondaryStationId,
							primaryDeliveryAmount,
							secondaryDeliveryAmount,
						} = stationDelivery;

						let gallonsForHalfLoad = GALLONS_FOR_HALF_LOAD;
						if (primaryStationId === R001_STATION_ID) {
							gallonsForHalfLoad = SPECIAL_GALLONS_FOR_HALF_LOAD;
						}

						const primaryStation = stationLookup[primaryStationId];
						if (primaryStation && primaryStation.gasFormulaId === BOYETT_GAS_FORMULA_ID) {
							gallonsForHalfLoad = BOYETT_GALLONS_FOR_HALF_LOAD;
						}

						//- Special case delivery to same station
						if (primaryStationId === secondaryStationId) {
							let amount = primaryDeliveryAmount;
							if (secondaryDeliveryAmount) {
								amount += secondaryDeliveryAmount;
							}

							if (amount >= gallonsForHalfLoad) {
								deliveryFreightType = 'freightFullLoad';
							} else {
								deliveryFreightType = 'freightHalfLoadNoSplit';
							}
						}

						//- full or half load unable to split
						else if (primaryStationId && !secondaryStationId) {
							if (primaryDeliveryAmount >= gallonsForHalfLoad) {
								deliveryFreightType = 'freightFullLoad';
							} else {
								deliveryFreightType = 'freightHalfLoadNoSplit';
							}
							//'freightFullLoad','freightHalfLoadSplit', 'freightHalfLoadNoSplit',
						}

						//- Anything taken to two sites is a half load split no matter the amount
						else if (primaryStationId && secondaryStationId) {
							deliveryFreightType = 'freightHalfLoadSplit';
						}
					}
				}
				*/

				//- Check if this is delivery addr
				if (
					!_.isEmpty(stationQuotedPrices) &&
					stationQuotedPrices[0].freightType === 'deliveryAdder'
				) {
					deliveryFreightType = 'deliveryAdder';
				}

				//- Lets try to figure out the best one
				let selectedQuotedStationPriceId = '';
				const defaultMMDD = moment(deliveryDate).format('MM_DD');
				stationQuotedPrices.forEach((stationQuotedPrice) => {
					const { stationQuotedPriceId, date, freightType } = stationQuotedPrice;

					if (moment(date).format('MM_DD') === defaultMMDD && freightType === deliveryFreightType) {
						selectedQuotedStationPriceId = stationQuotedPriceId;
					}
				});

				console.log(
					'stuff',
					deliveryFreightType,
					defaultMMDD,
					selectedQuotedStationPriceId,
					stationQuotedPrices
				);
				if (selectedQuotedStationPriceId) {
					newState.stationQuotedPriceId = selectedQuotedStationPriceId;
				}
				this.setState(newState);
			},
		});
	};

	getStateFromStationInvoice = (props) => {
		const { stationInvoice, invoiceDocumentMap, stationMap, quickbooksCustomerMap } = props;

		if (!stationInvoice) {
			return;
		}

		const newState = {};
		[
			'stationId',
			'quickbooksTermId',
			'issueDate',
			'deliveryDate',
			'carrierId',
			'carrierPoNumber',
			'invoiceDocumentIds',

			'actualTotalFreightCost',
			'actualUnleadedFuelCostPerGallon',
			'fuelCostPerGallon',

			//- Non gm
			'stationQuotedPriceId',

			//- all
			'calculatedWholesaleE85Price',
			'products',

			//- credit
			'creditAmount',
			'creditReason',
			'requireUnlPriceOnInvoicing',

			//- manual pricing
			'manualPricePerGallon',
			'manualPriceReason',
		].forEach((key) => {
			if (_.isNil(stationInvoice[key])) {
				return;
			}
			newState[key] = stationInvoice[key];
		});

		newState.isManualPricingUnlocked = !_.isNil(stationInvoice.manualPricePerGallon);

		const { invoiceDocumentIds, stationId, quickbooksTermId } = stationInvoice;

		//- Maybe don't do this here.....feels weird. The place that wants to use them should resolve them
		newState.invoiceDocuments = [];
		invoiceDocumentIds.forEach((invoiceDocumentId) => {
			const invoiceDocument = invoiceDocumentMap[invoiceDocumentId] || {
				invoiceDocumentId,
				documentType: 'Missing',
			};
			newState.invoiceDocuments.push(invoiceDocument);
		});

		let station;
		const errors = [];

		if (stationId) {
			station = stationMap[stationId];
			if (!station.invoiceQuickbooksCustomerId) {
				errors.push(
					<div key={errors.length}>
						<span>Station needs to be linked to a quickbooks customer first. </span>
						<a href={`/station/update/${stationId}`}>
							Update {station.number} - {station.name}
						</a>
					</div>
				);
			}
		}

		if (!quickbooksTermId && station) {
			if (station && station.invoiceQuickbooksCustomerId && quickbooksCustomerMap) {
				const cust = quickbooksCustomerMap[station.invoiceQuickbooksCustomerId];
				const customerQuickbooksTermId = _.get(cust, ['SalesTermRef', 'value']);
				if (customerQuickbooksTermId) {
					newState.quickbooksTermId = customerQuickbooksTermId;
				}
			}
		}

		if (!_.isEmpty(errors)) {
			newState.errors = errors;
		}

		return newState;
	};

	/*
	addInput = (arrayName) => {
		const val = _.cloneDeep(formFields[arrayName]);
		this.setState({[arrayName]: this.state[arrayName].concat(val)});
	};

	removeInput = (arrayName, index) => {
		const inputs = this.state[arrayName].slice();
		inputs.splice(index, 1);
		this.setState({[arrayName]: inputs});
	};
	*/

	/*
	onChange = (event, path) => {
		const {type, value, checked} = event.target;
		let val = (type === 'checkbox') ? checked : value;

		if (_.last(path) === 'netGallons') {
			val = parseInt(val, 10) || '';
		}

		this.change(val, path);
	};
	*/

	onChange = (value, path) => {
		const arrayPath = _.isString(path) ? _.toPath(path) : path;

		const val = _.isObject(value) && value.target ? value.target.value : value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), val);
			newState[basePath] = base;
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	};

	onTerminalSupplierChange = (value, path) => {
		const { terminalId, supplierId } = value;
		let newVal = { terminalId, supplierId };
		newVal = _.pickBy(newVal, (v) => {
			return !_.isUndefined(v);
		});

		if (_.keys(newVal).length) {
			const existing = _.get(this.state, path, {});
			newVal = _.assign({}, existing, newVal);
			this.onChange(newVal, path);
		}
	};

	closeSaveDocumentDialog = () => {
		this.setState({ isSaveDocumentDialogOpen: false });
	};

	closeSavingDialog = () => {
		this.setState({ onContinue: false });
	};

	continueSavingDialog = () => {
		this.props.history.push(`/accounting/stationInvoices`);
	};

	closeSendConfirmationDialog = () => {
		this.setState({ isSendConfirmationOpen: false });
		//this.props.history.push(`/accounting/stationInvoices`);
	};

	handleInvalidate = () => {
		this.setState({
			isConfirmInvalidateOpen: true,
		});
	};

	closeInvalidateDialog = () => {
		this.setState({ isConfirmInvalidateOpen: false });
	};

	handleSave = () => {
		const { showErrors } = this.props;

		this.save({
			callback: (err, r) => {
				if (err) {
					this.setState({ isSavingOpen: false });
					return showErrors(_.isArray(err) ? err : [err]);
				}

				const stationInvoice = _.get(r, ['collections', 'stationInvoiceCollection', 0]);
				if (!stationInvoice) {
					this.setState({ isSavingOpen: false });
					return showErrors(['Save did not return station invoice']);
				}

				this.setState({
					stationInvoiceForSending: stationInvoice,
					savingStatus: 'done',
				});
			},
		});
	};

	handleSaveAndSend = () => {
		const { showErrors, stationInvoice } = this.props;

		//- A rebill must send through the credit & rebill flow; wait for its credit memo
		//- (the backend refuses a plain send on a rebill as well)
		if (_.get(stationInvoice, ['rebillOfInvoiceId']) && !this.state.creditMemo) {
			//- A failed fetch would otherwise block sending forever; clear it so the
			//- next render refetches and "try again" actually works
			this.creditMemoFetchFailed = false;
			return showErrors([
				"Still loading this rebill's credit memo. Give it a second and try again.",
			]);
		}
		this.save({
			isSaveAndSend: true,
			callback: (err, r) => {
				if (err) {
					this.setState({ isSavingOpen: false });
					return showErrors(_.isArray(err) ? err : [err]);
				}

				const stationInvoice = _.get(r, ['collections', 'stationInvoiceCollection', 0]);
				if (!stationInvoice) {
					this.setState({ isSavingOpen: false });
					return showErrors(['Save did not return station invoice']);
				}

				this.setState({
					stationInvoiceForSending: stationInvoice,
					savingStatus: 'done',
				});

				setTimeout(() => {
					this.setState({
						isSavingOpen: false,
						isSendConfirmationOpen: true,
					});
				}, 500);
			},
		});
	};

	save = ({ isSaveAndSend, callback }) => {
		const {
			addStationInvoice,
			updateStationInvoice,
			stationMap,
			gasFormulaMap,
			stationInvoice,
		} = this.props;

		//- Required fields
		const formFieldError = {};
		const errors = [];

		const _setError = (path, error) => {
			_.set(formFieldError, path, error);
			errors.push(error);
		};

		const stationId = this.state.stationId;
		if (!stationId) {
			_setError(['stationId'], `Station is required`);
			this.setState({ formFieldError });
			return callback(errors);
		}

		const station = stationMap[stationId];
		if (!station) {
			return callback([`Station ${stationId} not found`]);
		}

		let fields = [
			{ fieldName: 'stationId', display: 'Station' },
			{ fieldName: 'issueDate', display: 'Issue Date' },
			{ fieldName: 'quickbooksTermId', display: 'Terms' },
		];

		if (isSaveAndSend) {
			fields.push(
				{ fieldName: 'carrierId', display: 'Carrier' },
				{ fieldName: 'carrierPoNumber', display: 'Delivery Ticket Number' },
				{ fieldName: 'deliveryDate', display: 'Delivery Date' }
			);
		}

		const { productType } = stationInvoice;
		const { gasFormulaId, biodieselFormulaId } = station;
		const isE85 = productType === 'e85';

		const isBdWithFormula = biodieselFormulaId && productType === 'b99';
		const isRd80 = biodieselFormulaId && productType === 'rd80/b20';

		let isGm,
			isFalcon,
			isHs,
			is29Palms = false;
		const requireUnlPriceOnInvoicing = this.state.requireUnlPriceOnInvoicing;

		if (isE85) {
			const gasFormula = gasFormulaMap[gasFormulaId];
			if (!gasFormula) {
				return callback(`Missing gasFormula : ${gasFormulaId}`);
			}
			const { formulaKey } = gasFormula;

			isGm = formulaKey === 'g&mE85';
			isFalcon = formulaKey === 'falconFormula';
			isHs = formulaKey === 'h&sE85' || formulaKey === 'h&sNew';
			is29Palms = formulaKey === '29Palms';
		}

		//- We are just "saving" we don't require some fields that might come at a later date
		if (isSaveAndSend) {
			if (isE85) {
				if (isGm) {
					fields.push(
						//{ fieldName: 'actualTotalFreightCost', display: 'Freight Cost' },
						{
							fieldName: 'actualUnleadedFuelCostPerGallon',
							display: 'Unleaded Fuel Cost',
						}
					);
					//- a manually priced G&M invoice still needs its quote (the true up reads it)
					if (this.state.isManualPricingUnlocked) {
						fields.push({ fieldName: 'stationQuotedPriceId', display: 'E85 Quoted Price' });
					}
				} else if (isFalcon || isHs) {
					fields.push(
						{ fieldName: 'actualTotalFreightCost', display: 'Freight Cost' },
						{ fieldName: 'stationQuotedPriceId', display: 'E85 Quoted Price' }
					);
				} else if (is29Palms) {
					fields.push(
						{ fieldName: 'actualTotalFreightCost', display: 'Freight Cost' },
						{ fieldName: 'stationQuotedPriceId', display: 'E85 Quoted Price' }
					);
				} else if (requireUnlPriceOnInvoicing) {
					fields.push(
						{
							fieldName: 'actualUnleadedFuelCostPerGallon',
							display: 'Unleaded Fuel Cost',
						},
						{ fieldName: 'stationQuotedPriceId', display: 'E85 Quoted Price' }
					);
				} else {
					fields.push({
						fieldName: 'stationQuotedPriceId',
						display: 'E85 Quoted Price',
					});
				}
			} else if (isBdWithFormula || isRd80) {
				fields.push({
					fieldName: 'stationQuotedPriceId',
					display: 'Biodiesel Quoted Price',
				});
			} else if (!this.state.isManualPricingUnlocked) {
				//- a manual price replaces the fuel cost entirely (no quote involved)
				fields.push({ fieldName: 'fuelCostPerGallon', display: 'Fuel Cost' });
			}
		}

		fields.forEach((s) => {
			if (_.isNil(this.state[s.fieldName]) || this.state[s.fieldName] === '') {
				_setError([s.fieldName], `${s.display} is required`);
			}
		});

		//- Manual pricing: on any save (not just send) a price and reason are required
		if (this.state.isManualPricingUnlocked && this.isManualPricingEditable()) {
			const { manualPricePerGallon, manualPriceReason } = this.state;
			//- same rounding the save sends (5 places), so the check matches the backend
			const price = this.parseManualPrice(manualPricePerGallon);
			if (_.isNil(manualPricePerGallon) || _.trim(manualPricePerGallon) === '') {
				_setError(['manualPricePerGallon'], 'Manual price per gallon is required');
			} else if (_.isNaN(price)) {
				_setError(['manualPricePerGallon'], 'Manual price per gallon must be a number like 2.15');
			} else if (price <= MANUAL_PRICE_MIN_EXCLUSIVE || price > MANUAL_PRICE_MAX) {
				_setError(
					['manualPricePerGallon'],
					`Manual price per gallon must be more than $${MANUAL_PRICE_MIN_EXCLUSIVE} and no more than $${MANUAL_PRICE_MAX}`
				);
			}
			if (!_.trim(manualPriceReason)) {
				_setError(['manualPriceReason'], 'A reason is required when using a manual price');
			} else if (_.trim(manualPriceReason).length > MANUAL_PRICE_REASON_MAX_LENGTH) {
				_setError(
					['manualPriceReason'],
					`Manual price reason must be ${MANUAL_PRICE_REASON_MAX_LENGTH} characters or less`
				);
			}
		}

		if (!_.isEmpty(errors)) {
			this.setState({ formFieldError });
			return callback(errors);
		}

		//- Get all the values and do individual checks
		const {
			isUpdate,
			issueDate,
			deliveryDate,
			quickbooksTermId,
			carrierId,
			carrierPoNumber,
			products,
			stationInvoiceId,
			invoiceDocuments,

			//- non G&M
			stationQuotedPriceId,

			//- Other
			actualTotalFreightCost,
			actualUnleadedFuelCostPerGallon,
			fuelCostPerGallon,

			calculatedWholesaleE85Price,
			creditReason,
		} = this.state;

		let creditAmount = this.state.creditAmount;

		if (isE85 && isSaveAndSend) {
			if (isGm || requireUnlPriceOnInvoicing) {
				if (!calculatedWholesaleE85Price) {
					return callback('Could not calculate E85 Price. Please check all values');
				}
			}
		}

		if (creditAmount) {
			if (!creditReason) {
				errors.push('Credit reason required when entering a credit amount');
			}

			creditAmount = parseFloat(creditAmount);
			if (!creditAmount) {
				errors.push('Credit amount must be a valid number');
			}
			if (creditAmount < 0) {
				errors.push(
					'Credit amount should not be negative. The value will be subtracted on invoice'
				);
			}
		}

		if (actualUnleadedFuelCostPerGallon) {
			if (actualUnleadedFuelCostPerGallon > 6) {
				return callback(`Unleaded fuel is above 6 dollars. Please recheck your values`);
			}
		}

		let totalGallons = 0;
		products.forEach((product, index) => {
			const { terminalSupplier, bolNumbers, netGallons } = product;
			const { terminalId, supplierId } = terminalSupplier;

			if (!terminalId || !supplierId) {
				_setError(['products', index, 'terminalSupplier'], 'Terminal & Supplier required');
			}
			bolNumbers.forEach((bolNumber, bIndex) => {
				if (!bolNumber) {
					_setError(['products', index, 'bolNumbers', bIndex], 'BOL Number required');
				}
			});

			if (!netGallons) {
				_setError(['products', index, 'netGallons'], 'Net Gallons required');
			}

			if (netGallons >= 8800) {
				_setError(
					['products', index, 'netGallons'],
					'Net Gallons is greater than 8800! Probably a typo?'
				);
			}
			totalGallons += parseInt(netGallons, 10);
			if (!_.isNumber(netGallons)) {
				product.netGallons = parseInt(netGallons, 10);
			}
		});

		if (totalGallons >= 10000) {
			return callback(`Total gallons above 10,000. Please recheck your fuel values`);
		}

		if (!_.isEmpty(errors)) {
			this.setState({ formFieldError });
			return callback(errors);
		}

		const sortedInvoiceDocuments = _.orderBy(
			invoiceDocuments,
			({ documentType, name }) => {
				if (!documentType) {
					return 99;
				}
				return (documentTypeSort[documentType] || 98) + '_' + name;
			},
			'asc'
		);
		const invoiceDocumentIds = _.compact(_.map(sortedInvoiceDocuments, 'invoiceDocumentId'));

		//- Lock and load
		const params = {
			stationId,
			issueDate,
			deliveryDate,
			quickbooksTermId,
			carrierId,
			carrierPoNumber,
			invoiceDocumentIds,
			products,
			stationQuotedPriceId,
			creditAmount,
			creditReason,
		};

		const _f = (v) => {
			if (_.isNumber(v)) {
				return parseFloat(v.toFixed(5));
			} else if (_.isString(v)) {
				return parseFloat(parseFloat(v).toFixed(5));
			} else {
				return v;
			}
		};

		if (isE85) {
			if (isGm) {
				if (actualTotalFreightCost) {
					params.actualTotalFreightCost = parseFloat(actualTotalFreightCost);
				}
				if (actualUnleadedFuelCostPerGallon) {
					params.actualUnleadedFuelCostPerGallon = parseFloat(actualUnleadedFuelCostPerGallon);
				}
				if (calculatedWholesaleE85Price) {
					params.calculatedWholesaleE85Price = _f(calculatedWholesaleE85Price);
				}
			} else if (isFalcon || isHs) {
				if (actualTotalFreightCost) {
					params.actualTotalFreightCost = parseFloat(actualTotalFreightCost);
				}
				params.stationQuotedPriceId = stationQuotedPriceId;
			} else if (is29Palms) {
				if (actualTotalFreightCost) {
					params.actualTotalFreightCost = parseFloat(actualTotalFreightCost);
				}
				params.stationQuotedPriceId = stationQuotedPriceId;
			} else if (requireUnlPriceOnInvoicing) {
				params.stationQuotedPriceId = stationQuotedPriceId;
				if (actualUnleadedFuelCostPerGallon) {
					params.actualUnleadedFuelCostPerGallon = parseFloat(actualUnleadedFuelCostPerGallon);
				}
				if (calculatedWholesaleE85Price) {
					params.calculatedWholesaleE85Price = _f(calculatedWholesaleE85Price);
				}
			} else {
				params.stationQuotedPriceId = stationQuotedPriceId;
			}
		} else if (isBdWithFormula) {
			if (actualTotalFreightCost) {
				params.actualTotalFreightCost = parseFloat(actualTotalFreightCost);
			}
			params.stationQuotedPriceId = stationQuotedPriceId;
		} else if (isRd80) {
			params.stationQuotedPriceId = stationQuotedPriceId;
		} else {
			if (fuelCostPerGallon) {
				params.fuelCostPerGallon = parseFloat(fuelCostPerGallon);
			}
			if (actualTotalFreightCost) {
				params.actualTotalFreightCost = parseFloat(actualTotalFreightCost);
			}
		}

		//- Manual pricing only goes up while the invoice is pending (or new). Locked always sends
		//- null: it clears a saved manual price and is a no-op on the backend when there is none
		//- (so a revert works even if the save that set the price errored afterwards).
		if (this.isManualPricingEditable()) {
			if (this.state.isManualPricingUnlocked) {
				params.manualPricePerGallon = this.parseManualPrice(this.state.manualPricePerGallon);
				params.manualPriceReason = _.trim(this.state.manualPriceReason);
			} else {
				params.manualPricePerGallon = null;
			}
		}

		this.setState({
			isSavingOpen: true,
			savingStatus: 'saving',
		});

		if (!isUpdate) {
			addStationInvoice({
				params,
				callback,
			});
		} else {
			params.stationInvoiceId = stationInvoiceId;
			updateStationInvoice({
				params,
				callback,
			});
		}
	};

	//- New documents or updates to existing ones
	handleNewInvoiceDocuments = (r) => {
		const newInvoiceDocuments = r.invoiceDocuments;
		const existingInvoiceDocuments = this.state.invoiceDocuments;

		const newState = {};
		let invoiceDocuments = newInvoiceDocuments;
		existingInvoiceDocuments.forEach((existing) => {
			if (
				!_.find(invoiceDocuments, {
					invoiceDocumentId: existing.invoiceDocumentId,
				})
			) {
				invoiceDocuments.push(existing);
			}
		});
		newState.invoiceDocuments = invoiceDocuments;

		//- Go through the new documents and set any values that are not set already
		//const invoiceDocuments = existingInvoiceDocuments.concat(newInvoiceDocuments);

		//- Go through all documents and get the which products
		const fuelMap = {};
		invoiceDocuments.forEach((invoiceDocument) => {
			const { documentType, data } = invoiceDocument;
			const { productType } = data;

			//- BOL
			if (productType) {
				const { terminalSupplier, bolNumber, netGallons } = data;
				if (!fuelMap[productType]) {
					fuelMap[productType] = {
						productType,
						terminalSupplier,
						bolNumbers: [],
						netGallons: 0,
					};
				}
				fuelMap[productType].bolNumbers.push(bolNumber);
				fuelMap[productType].netGallons += parseInt(netGallons, 10);
			}

			//- Carrier
			if (documentType === 'carrierDeliveryTicket') {
				const { carrierId, carrierPoNumber, deliveryDate } = data;
				newState.carrierId = carrierId;
				newState.carrierPoNumber = carrierPoNumber;
				newState.deliveryDate = deliveryDate;
				newState.issueDate = deliveryDate;
			}
		});

		newState.products = _.values(fuelMap);
		this.setState(newState);
	};

	handleDataFileUpload = ({ resource }) => {
		const { convertToPages, showErrors } = this.props;
		this.setState({ isConvertingToPages: true });
		convertToPages({
			params: {
				documentResourceId: resource.resourceId,
			},
			callback: (err, convertToPagesResult) => {
				const newState = {
					isConvertingToPages: false,
				};

				if (err) {
					this.setState(newState);
					return showErrors([err]);
				}

				newState.convertToPagesResult = convertToPagesResult;
				newState.isSaveDocumentDialogOpen = true;
				newState.invoiceDocumentsToModify = null;

				this.setState(newState);
			},
		});
	};

	handleRemoveInvoiceDocument = ({ invoiceDocumentId }) => {
		const { invoiceDocumentIds, invoiceDocuments } = this.state;

		const newInvoiceDocumentIds = _.filter(invoiceDocumentIds, (id) => {
			return id !== invoiceDocumentId;
		});

		const newInvoiceDocuments = _.filter(invoiceDocuments, (invoiceDocument) => {
			return invoiceDocument.invoiceDocumentId !== invoiceDocumentId;
		});

		this.setState({
			invoiceDocumentIds: newInvoiceDocumentIds,
			invoiceDocuments: newInvoiceDocuments,
		});
	};

	handleEditInvoiceDocument = ({ invoiceDocument }) => {
		const newState = {};
		newState.isSaveDocumentDialogOpen = true;
		newState.convertToPagesResult = null;
		newState.invoiceDocumentsToModify = [invoiceDocument];
		this.setState(newState);
	};

	onDocumentClick = (invoiceDocument) => {
		this.setState({
			isInvoiceDocumentPopupOpen: true,
			invoiceDocumentPoppedUp: invoiceDocument,
		});
	};

	handleCloseInvoiceDocumentPopupOpen = () => {
		this.setState({
			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentPoppedUp: undefined,
		});
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render() {
		const {
			authUser,
			classes,
			stationInvoice,
			carriers,
			terminals,
			showErrors,
			invalidateStationInvoice,
			supplierMap,
			stationDeliveryMap,
			//invoiceDocumentMap,
			//stationMap,
			resourceMap,
		} = this.props;

		const {
			isUpdate,
			stationInvoiceId,
			isSaveDocumentDialogOpen,
			isSendConfirmationOpen,
			convertToPagesResult,
			invoiceDocumentsToModify,
			//formFieldError,
			isConvertingToPages,

			//- Put here from initial load and from uploading new ones
			isSavingOpen,
			savingStatus,
			isConfirmInvalidateOpen,
			invoiceDocuments,
			errors,
			stationInvoiceForSending,
		} = this.state;

		const c = classes;
		if (!terminals.length || !carriers.length) {
			return <div>Fetching information...</div>;
		}

		if (isUpdate && !stationInvoice) {
			return <div>Fetching station invoice information...</div>;
		}

		//- Figure out some shit and save it
		let linkedStationDeliveryId;

		if (stationInvoice) {
			linkedStationDeliveryId = stationInvoice.linkedStationDeliveryId;
		}

		let stationDelivery;
		const hasDelivery = !!linkedStationDeliveryId;
		if (linkedStationDeliveryId) {
			stationDelivery = stationDeliveryMap[linkedStationDeliveryId];
		}

		const { uploadedInvoiceDocuments, missingInvoiceDocuments } = getDocuments({
			invoiceDocuments, //- Ones we have
			stationDelivery, //- Helps us determine ones we need
			carrierMap: _.keyBy(carriers, 'carrierId'),
			terminalMap: _.keyBy(terminals, 'terminalId'),
			supplierMap,
		});

		/*
		let isRequiredCount = 0;
		let hasInvoiceDocumentCount = 0;
		documents.forEach(document => {
			if (document.isRequired) {
				isRequiredCount++;
			}
			if (document.hasInvoiceDocument) {
				hasInvoiceDocumentCount++;
			}
		});
		*/

		//const isMissingRequiredDocs = (isRequiredCount > hasInvoiceDocumentCount);
		const isMissingRequiredDocs = !_.isEmpty(missingInvoiceDocuments);

		//const verb = (isUpdate) ? 'Update' : 'Add';
		const headline = isUpdate
			? `Update Station Invoice #${stationInvoiceId}`
			: `Add Station Invoice`;

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					{!_.isEmpty(errors) && (
						<div className={classes.topErrors}>
							{errors.map((error) => {
								return error;
							})}
						</div>
					)}

					<FMPHeadline label={headline} />

					{hasDelivery && this.renderStationDelivery({ stationDelivery })}
					{!hasDelivery && this.renderNoStationDelivery()}

					<Paper className={classes.paper}>
						<FMPRegionHeader isTop={true} label="Delivery Documents" />

						<Grid container spacing={3}>
							<Grid item xs={12} md={4}>
								<ResourceUploader
									name={'dataFileResourceId'}
									label={''}
									afterUpload={this.handleDataFileUpload}
									onlyOne={true}
									customProgress={isConvertingToPages ? 'Converting...' : undefined}
								/>
							</Grid>
							<Grid item xs={12} md={8}>
								<div style={{ paddingTop: 10 }}>
									{uploadedInvoiceDocuments.map((invoiceDocument, i) => {
										const { invoiceDocumentId, name, details, documentType } = invoiceDocument;

										return (
											<div className={classes.documentContainer} key={i}>
												<div className={classes.documentInfoContainer}>
													<InvoiceDocumentIcon
														invoiceDocument={invoiceDocument}
														resourceMap={resourceMap}
														onClick={this.onDocumentClick}
													/>

													<div className={c.documentInfo}>
														<div className={c.documentName}>{name || documentType}</div>
														<div className={c.documentDetails}>{details}</div>
													</div>
												</div>
												<div className={classes.documentIcons}>
													<IconButton
														aria-label="Edit"
														className={classes.button}
														onClick={() => {
															this.handleEditInvoiceDocument({
																invoiceDocument,
															});
														}}
													>
														<EditIcon />
													</IconButton>

													<IconButton
														aria-label="Delete"
														className={classes.button}
														onClick={() => {
															this.handleRemoveInvoiceDocument({
																invoiceDocumentId,
															});
														}}
													>
														<DeleteIcon />
													</IconButton>
												</div>
											</div>
										);
									})}

									{missingInvoiceDocuments.map((missingInvoiceDocument, j) => {
										const { isRequired, name } = missingInvoiceDocument;
										return (
											<div className={classes.documentContainer} key={j}>
												<div className={classes.documentInfoContainer}>
													<InvoiceDocumentIcon
														invoiceDocument={missingInvoiceDocument}
														isMissing={true}
													/>
													<div className={c.documentInfo}>
														<div className={c.missingDocumentName}>Need {name}</div>
														{isRequired && <div className={c.documentRequired}>*required</div>}
														{!isRequired && <div className={c.documentRequired}>*optional</div>}
													</div>
												</div>
											</div>
										);
									})}
								</div>
							</Grid>
						</Grid>
						{authUser.userId === 14 && (
							<Grid container spacing={3}>
								<Grid item xs={6}>
									<Button
										onClick={() => {
											this.handleDataFileUpload({
												resource: { resourceId: 777777777 },
											});
										}}
									>
										Test Document
									</Button>
								</Grid>
							</Grid>
						)}
					</Paper>

					<Paper className={classes.paper}>
						<FMPRegionHeader isTop={true} label="Invoice Info" />

						{!!stationInvoice && this.displayStatus({ stationInvoice })}

						{isMissingRequiredDocs && (
							<div className={classes.missingRequiredDocs}>
								Please first add all required delivery documents. Then the invoice information will
								be available.
							</div>
						)}

						{!isMissingRequiredDocs && this.renderInvoiceFields()}

						{stationDelivery && stationDelivery.internalNote && (
							<div style={{ marginTop: 20 }}>
								<Note>
									<strong style={{ fontSize: '13px' }}>Delivery Internal Note</strong>{' '}
									<pre
										style={{
											margin: 0,
											paddingLeft: 10,
											wordWrap: 'break-word',
											whiteSpace: 'pre-wrap',
										}}
									>
										{stationDelivery.internalNote}
									</pre>
								</Note>
							</div>
						)}

						{this.renderButtons({
							isMissingRequiredDocs,
							stationInvoice,
							isUpdate,
							stationDelivery,
						})}
					</Paper>

					<GenericSavingDialog
						open={isSavingOpen}
						onClose={this.closeSavingDialog}
						onContinue={this.continueSavingDialog}
						processingText={'Processing and saving invoice.'}
						successText={'Invoice saved successfully.'}
						status={savingStatus}
					/>

					<ConfirmInvalidateStationInvoiceDialog
						open={isConfirmInvalidateOpen}
						onClose={this.closeInvalidateDialog}
						stationInvoice={stationInvoice}
						invalidateStationInvoice={invalidateStationInvoice}
						showErrors={showErrors}
						history={this.props.history}
					/>

					<InvoiceSendConfirmationDialog
						stationInvoice={stationInvoiceForSending}
						creditMemo={
							_.get(stationInvoice, ['rebillOfInvoiceId']) ? this.state.creditMemo : undefined
						}
						open={isSendConfirmationOpen}
						onClose={this.closeSendConfirmationDialog}
						history={this.props.history}
					/>

					<CreditRebillDialog
						open={!!this.state.isCreditRebillOpen}
						onClose={() => this.setState({ isCreditRebillOpen: false })}
						stationInvoice={stationInvoice}
						stations={this.props.stations}
						history={this.props.history}
					/>

					<SaveInvoiceDocumentsDialog
						open={isSaveDocumentDialogOpen}
						onClose={this.closeSaveDocumentDialog}
						convertToPagesResult={convertToPagesResult}
						invoiceDocuments={invoiceDocumentsToModify}
						stationDelivery={stationDelivery}
						showErrors={showErrors}
						terminals={terminals}
						carriers={carriers}
						supplierMap={supplierMap}
						stationDeliveryMap={stationDeliveryMap}
						stationInvoice={stationInvoice}
						onNewInvoiceDocuments={this.handleNewInvoiceDocuments}
					/>

					<InvoiceDocumentPopup
						open={this.state.isInvoiceDocumentPopupOpen}
						onClose={this.handleCloseInvoiceDocumentPopupOpen}
						invoiceDocument={this.state.invoiceDocumentPoppedUp}
						resourceMap={resourceMap}
					/>

					<InvoicePdfPopup
						open={this.state.isInvoicePdfPopupOpen}
						onClose={this.handleCloseInvoicePdfPopup}
						resourceId={this.state.invoicePdfPoppedUp}
						resourceMap={resourceMap}
					/>
				</Grid>
			</Grid>
		);
	}

	onInvoiceClick = (resourceId) => {
		this.setState({
			isInvoicePdfPopupOpen: true,
			invoicePdfPoppedUp: resourceId,
		});
	};
	handleCloseInvoicePdfPopup = () => {
		this.setState({
			isInvoicePdfPopupOpen: false,
			invoicePdfPoppedUp: undefined,
		});
	};

	displayStatus = ({ stationInvoice }) => {
		const { classes } = this.props;
		const { creditMemo } = this.state;
		const {
			status,
			invalidReason,
			collatedResourceId,
			quickbooksInvoiceUrl,
			total,
			rebillOfInvoiceId,
			creditMemoId,
		} = stationInvoice;

		let invoiceTotal = <span>{moneyFormatter.format(total)}</span>;
		let onInvoiceClick = () => {
			this.onInvoiceClick(collatedResourceId);
		};

		return (
			<div style={{ padding: '10px', border: '1px solid #eee', display: 'flex' }}>
				<div>
					<div>
						<span>Invoice Status : </span>
						<span style={invoiceStatusClassNames[status]}>{statusToDisplay[status]}</span>
					</div>

					{status === 'invalid' && !!invalidReason && (
						<div>
							<span>Invalid Reason: {invalidReason}</span>
						</div>
					)}

					{!!creditMemoId && (
						<div>
							<span>
								{rebillOfInvoiceId ? 'Credit Memo: ' : 'Credited by: '}
								<a href={`/accounting/creditMemos`}>#{creditMemoId}</a>
								{!!creditMemo && <span> ({creditMemo.status})</span>}
							</span>
						</div>
					)}

					{!!rebillOfInvoiceId && (
						<div>
							<span>
								Rebill of invoice{' '}
								<a href={`/accounting/stationInvoice/update/${rebillOfInvoiceId}`}>
									#{rebillOfInvoiceId}
								</a>
							</span>
						</div>
					)}

					{!rebillOfInvoiceId && !!creditMemo && !!creditMemo.rebillInvoiceId && (
						<div>
							<span>
								Rebilled as{' '}
								<a href={`/accounting/stationInvoice/update/${creditMemo.rebillInvoiceId}`}>
									#{creditMemo.rebillInvoiceId}
								</a>
							</span>
						</div>
					)}
				</div>

				{!!invoiceTotal && (
					<div style={{ marginLeft: 20 }}>
						<div style={{ fontSize: 14, color: '#666', fontWeight: 'bold' }}>Invoice Total</div>
						<div>{invoiceTotal}</div>
					</div>
				)}

				{!!collatedResourceId && (
					<div style={{ marginLeft: 20 }}>
						<div style={{ fontSize: 14, color: '#666', fontWeight: 'bold' }}>Invoice PDF</div>
						<div className={classes.invoiceIcon} onClick={onInvoiceClick} />
					</div>
				)}

				{!!quickbooksInvoiceUrl && (
					<div style={{ marginLeft: 20 }}>
						<div style={{ fontSize: 14, color: '#666', fontWeight: 'bold' }}>Quickbooks URL</div>
						<a href={quickbooksInvoiceUrl} target="_blank" rel="noreferrer noopener">
							<div className={classes.quickbooksIcon} />
						</a>
					</div>
				)}
			</div>
		);
	};

	renderButtons = ({ isMissingRequiredDocs, stationInvoice, isUpdate, stationDelivery }) => {
		const { isMissingQuotedPrices, creditMemo } = this.state;
		const { canCreditRebillInvoices } = this.props;
		const status = _.get(stationInvoice, ['status'], 'new');

		//- Fully credited: the credit memo and (optional) rebill carry on from here
		if (status === 'credited') {
			return (
				<div style={{ textAlign: 'right', margin: '20px 10px', color: '#999' }}>
					This invoice has been fully credited
					{!!creditMemo && <span> by credit memo #{creditMemo.invoiceCreditMemoId}</span>}. It can
					no longer be changed.
				</div>
			);
		}

		if (status === 'issued' && isUpdate) {
			const canShowCreditRebill =
				canCreditRebillInvoices &&
				!!stationInvoice.quickbooksInvoiceId &&
				!stationInvoice.creditMemoId;

			return (
				<div style={{ textAlign: 'right', margin: '20px 10px' }}>
					{canShowCreditRebill && (
						<Button
							onClick={() => this.setState({ isCreditRebillOpen: true })}
							variant="outlined"
							style={{ margin: '0px 10px', color: '#9C27B0', borderColor: '#9C27B0' }}
						>
							Credit &amp; Rebill
						</Button>
					)}

					<Button onClick={this.handleInvalidate} variant="outlined" style={{ margin: '0px 10px' }}>
						Mark Invalid
					</Button>

					<Button
						onClick={this.handleSave}
						variant="outlined"
						color="primary"
						style={{ margin: '0px 10px' }}
						disabled={isMissingQuotedPrices}
					>
						Save Invoice
					</Button>

					{isMissingQuotedPrices && (
						<div style={{ marginTop: 5, color: '#999' }}>Cannot save. Missing quoted prices</div>
					)}
				</div>
			);
		}

		const { stationInvoiceId } = this.state;
		let { isSendDisabled, disabledReasons } = this.getIsSendDisabled({
			isMissingRequiredDocs,
			stationDelivery,
		});

		//- A rebill deliberately diverges from the recorded delivery (wrong station, fixed
		//- gallons/price), so delivery-reconciliation mismatches warn but don't block it.
		//- Hard blocks (missing documents, missing delivery) still apply.
		const isRebill = !!_.get(stationInvoice, ['rebillOfInvoiceId']);
		const isHardBlocked = isMissingRequiredDocs || !stationDelivery;
		if (isRebill && !isHardBlocked) {
			isSendDisabled = false;
		}

		const { classes } = this.props;
		return (
			<div>
				{!_.isEmpty(disabledReasons) && (
					<div
						style={{
							margin: '20px 10px',
						}}
					>
						<Note>
							<div style={{ fontSize: '120%' }}>
								{isRebill && !isSendDisabled
									? 'Heads up — this rebill does not match the recorded delivery (expected for a correction, but double-check the values):'
									: 'Save & Send is currently disabled until the following issues are reconciled with the delivery:'}
							</div>
							{disabledReasons.map((disabledReason) => {
								return (
									<div key={disabledReason}>
										<WarningIcon className={classes.warningIcon} />
										{disabledReason}
									</div>
								);
							})}

							<Button
								style={{ marginTop: 10 }}
								variant="outlined"
								color="primary"
								onClick={() => {
									this.copyToClipboard(
										`https://fmp.pearsonfuels.com/accounting/stationInvoice/update/${stationInvoiceId}`
									);
								}}
							>
								Copy FMP Invoice URL to clipboard
							</Button>
						</Note>
					</div>
				)}

				<div style={{ textAlign: 'right', margin: '20px 10px' }}>
					<Button onClick={this.handleClose} variant="outlined" style={{ margin: '0px 10px' }}>
						Cancel
					</Button>

					<Button onClick={this.handleInvalidate} variant="outlined" style={{ margin: '0px 10px' }}>
						Mark Invalid
					</Button>

					<Button
						onClick={this.handleSave}
						variant="outlined"
						color="primary"
						style={{ margin: '0px 10px' }}
						disabled={isMissingQuotedPrices}
					>
						Save Invoice
					</Button>

					<FMPSubmitButton
						onClick={this.handleSaveAndSend}
						buttonText={
							_.get(stationInvoice, ['rebillOfInvoiceId'])
								? `Save & Send Credit & Rebill`
								: `Save & Send Invoice`
						}
						isDisabled={isSendDisabled}
						disabledText={'Disabled until issues are reconciled'}
					/>

					{isMissingQuotedPrices && (
						<div style={{ marginTop: 5, color: '#999' }}>Cannot save. Missing quoted prices</div>
					)}
				</div>

				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right',
					}}
					open={this.state.snackbarIsOpen}
					autoHideDuration={2000}
					onClose={this.handleSnackbarClose}
					TransitionComponent={SlideUpTransition}
				>
					<SnackbarContent
						className={classes.snackbarSuccess}
						aria-describedby="client-snackbar"
						message={
							<span id="client-snackbar" className={classes.snackbarMessage}>
								<CheckCircleIcon className={classes.snackbarIcon} />
								<strong>{this.state.snackbarMessage} </strong>
							</span>
						}
						action={[
							<IconButton
								key="close"
								aria-label="close"
								color="inherit"
								onClick={this.handleSnackbarClose}
							>
								<CloseIcon className={classes.icon} />
							</IconButton>,
						]}
					/>
				</Snackbar>
			</div>
		);
	};

	copyToClipboard = (text) => {
		this.setState({
			snackbarMessage: `Copied FMP Invoice URL to the clipboard`,
			snackbarIsOpen: true,
		});

		navigator.clipboard.writeText(text).then(
			() => {},
			function (err) {
				console.error('Async: Could not copy text: ', err);
			}
		);
	};

	getIsSendDisabled = ({ isMissingRequiredDocs, stationDelivery }) => {
		if (isMissingRequiredDocs) {
			return { isSendDisabled: true, disabledReasons: ['Missing documents'] };
		}

		if (!stationDelivery) {
			return { isSendDisabled: true, disabledReasons: ['Missing station delivery'] };
		}

		let isSendDisabled = false;
		const disabledReasons = [];
		const { carrierId } = this.state;
		if (!carrierId || carrierId !== stationDelivery.carrierId) {
			isSendDisabled = true;
			disabledReasons.push('Delivery Carrier and Invoice Carrier did not match');
		}

		//const { terminals, stationDeliveryMap, supplierMap, classes, stationInvoice } = this.props;
		const { stationDeliveryMap, stationInvoice, terminalMap, supplierMap } = this.props;
		const { products } = this.state;

		products.forEach((product) => {
			const { productType, netGallons, terminalSupplier } = product;

			const { terminalId, supplierId } = terminalSupplier;
			// const productTypeDisplay = valueToDisplay(productType);

			const matchResult = matchProductToDelivery({
				stationDeliveryMap,
				stationInvoice,
				productType,
				netGallons: parseInt(netGallons, 10),
				terminalId,
				supplierId,
				terminalMap,
				supplierMap,
			});

			if (!_.isEmpty(matchResult.reasonsForNotMatching)) {
				const reasons = matchResult.reasonsForNotMatching;
				isSendDisabled = true;
				reasons.forEach((reason) => {
					disabledReasons.push(`${_.upperFirst(productType)}: ${reason}`);
				});
			}

			if (matchResult.reasonForTerminalNotMatching) {
				isSendDisabled = true;
				disabledReasons.push(matchResult.reasonForTerminalNotMatching);
			}

			if (matchResult.reasonForSupplierNotMatching) {
				isSendDisabled = true;
				disabledReasons.push(matchResult.reasonForSupplierNotMatching);
			}

			const { deliveryDate } = this.state;

			//
			//- See if the deliveryDate matches documents and delivery
			//
			let deliveryMoment = moment();
			//- Open the invoice at the beginning of the window
			if (stationDelivery.allDayWindow) {
				deliveryMoment = moment(stationDelivery.deliveryWindowStartDateTime);
			} else if (stationDelivery.deliveryWindowStartDateTime) {
				deliveryMoment = moment(stationDelivery.deliveryWindowStartDateTime);
			} else if (stationDelivery.deliveryWindowEndDateTime) {
				deliveryMoment = moment(stationDelivery.deliveryWindowEndDateTime);
			}

			if (deliveryMoment.format('YYYY-MM-DD') !== deliveryDate) {
				disabledReasons.push(
					`Delivery date on invoice does not match date on delivery: ` +
						deliveryMoment.format('M/D')
				);
				isSendDisabled = true;
			}
		});

		return { isSendDisabled, disabledReasons };
	};

	renderStationDelivery = () => {
		const {
			stationDeliveryMap,
			classes,
			carriers,
			terminals,
			supplierMap,
			stationMap,
			stationInvoice,
		} = this.props;
		const { linkedStationDeliveryId, stationId } = stationInvoice;

		//- We might not have a station delivery
		const stationDelivery = stationDeliveryMap[linkedStationDeliveryId];

		if (!stationDelivery) {
			return <div>Missing the linked station delivery : #{linkedStationDeliveryId}</div>;
		}

		this.stationDelivery = stationDelivery;

		const {
			isTwo,
			dateLine1,
			dateLine2,
			carrierId,
			status,
			firstTerminalTerminalId,
			primaryProductType,
			firstTerminalSupplierId,
			secondTerminalTerminalId,
			secondTerminalSupplierId,
			//isE85,
			isDualFuelPickup,
			primaryStationId,
			secondaryStationId,
			//
			note,
			internalNote,
		} = stationDelivery;

		const carrier = (this.stationDelivery.carrier = _.find(carriers, {
			carrierId,
		}) || { name: `MISSING CARRIER: ${carrierId}` });

		this.stationDelivery.firstTerminalTerminal = _.find(terminals, {
			terminalId: firstTerminalTerminalId,
		}) || { name: `MISSING First Terminal:${firstTerminalTerminalId}` };

		this.stationDelivery.firstTerminalSupplier = supplierMap[firstTerminalSupplierId] || {
			name: `MISSING First Terminal Supplier:${firstTerminalSupplierId}`,
		};

		if (primaryProductType === 'e85') {
			this.stationDelivery.secondTerminalTerminal = _.find(terminals, {
				terminalId: secondTerminalTerminalId,
			}) || { name: `MISSING Second Terminal:${secondTerminalTerminalId}` };

			this.stationDelivery.secondTerminalSupplier = supplierMap[secondTerminalSupplierId] || {
				name: `MISSING Second supplier (ETOH) :${secondTerminalSupplierId}`,
			};
		}

		this.stationDelivery.primaryStation = stationMap[primaryStationId] || {
			number: 'XXX',
			name: `MISSING PRIMARY STATION:${primaryStationId}`,
		};

		if (secondaryStationId) {
			this.stationDelivery.secondaryStation = stationMap[secondaryStationId] || {
				number: 'XXX',
				name: `MISSING SECONDARY STATION:${secondaryStationId}`,
			};
		}

		//- One entry per stop (leg), each with its station resolved
		const legs = getDeliveryLegs(stationDelivery);
		this.stationDelivery.legsWithStations = legs.map((leg) => ({
			...leg,
			station: stationMap[leg.stationId] || {
				number: 'XXX',
				name: `MISSING STATION:${leg.stationId}`,
			},
		}));

		const { statusClassName } = formatStatus(status);

		let kindOfOrder = '';
		if (legs.length >= 2) {
			const matchedLegNumbers = legs
				.filter((leg) => leg.stationId === stationId)
				.map((leg) => leg.legNumber);
			const distinctStations = new Set(legs.map((leg) => leg.stationId)).size;

			if (distinctStations === 1 && matchedLegNumbers.length === legs.length) {
				kindOfOrder = 'Dual load to same station';
			} else if (matchedLegNumbers.length) {
				kindOfOrder =
					`Split load - Invoice is for stop` +
					`${matchedLegNumbers.length > 1 ? 's' : ''} #${matchedLegNumbers.join(', #')}`;
			} else {
				kindOfOrder = 'Problem : Split load and station on invoice did not match any stop';
			}
		}

		return (
			<Accordion className={classes.paper} style={{ marginTop: 0, paddingBottom: 10 }}>
				<AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ padding: 0 }}>
					<FMPRegionHeader isTop={true} label={`Linked Delivery : #${linkedStationDeliveryId}`} />
				</AccordionSummary>
				<AccordionDetails style={{ display: 'block' }}>
					<div className={classes.linkedTo}>
						<div>
							Linked to{' '}
							<strong>
								Delivery #
								<a
									href={`/logistics/stationDelivery/update/${linkedStationDeliveryId}`}
									target="_blank"
									rel="noreferrer noopener"
								>
									{linkedStationDeliveryId}
								</a>
							</strong>
						</div>
						<div className={classes.linkedStatus}>
							Status: <span className={classes[statusClassName]}>{_.startCase(status)}</span>
						</div>
					</div>

					{kindOfOrder && (
						<div
							style={{
								border: '1px solid #ddd',
								backgroundColor: '#eef8ff',
								marginTop: 10,
								padding: 20,
							}}
						>
							{kindOfOrder}
						</div>
					)}

					<FMPSectionHeader label={'Carrier'} />
					<div className={classes.inset}>
						<div>{carrier.name}</div>
					</div>

					<FMPSectionHeader label={'Delivery Window'} />
					<div className={classes.inset}>
						<div>{dateLine1}</div>
						<div>{dateLine2}</div>
					</div>

					{/* Fuel deliveries — one section per stop */}
					{this.stationDelivery.legsWithStations.map((leg) => (
						<Fragment key={leg.legNumber}>
							<FMPSectionHeader label={`Fuel Delivery ${isTwo ? `#${leg.legNumber}` : ''}`} />
							{this.renderFuelDelivery({
								leg,
								highlight: leg.stationId === stationId,
							})}
						</Fragment>
					))}

					{this.renderTerminal({ whichOne: 'first' })}

					{isDualFuelPickup && this.renderTerminal({ whichOne: 'second' })}

					<FMPSectionHeader label={`Notes`} />
					<div className={classes.inset}>
						{note && (
							<div>
								<strong>Email Note: </strong>
								<div style={{ whiteSpace: 'pre' }}>{note}</div>
							</div>
						)}
						{internalNote && (
							<div>
								<strong>Internal Note: </strong>
								<div style={{ whiteSpace: 'pre' }}>{internalNote}</div>
							</div>
						)}
					</div>
				</AccordionDetails>
			</Accordion>
		);
	};

	renderNoStationDelivery = () => {
		const { classes } = this.props;
		return (
			<Paper className={classes.paper} style={{ marginTop: 0, paddingBottom: 10 }}>
				<div className={classes.noDelivery}>
					<div className={classes.noDeliveryIcon} />
					<span>No station delivery linked to this invoice.</span>
				</div>
			</Paper>
		);
	};

	renderFuelDelivery = ({ leg, highlight }) => {
		const { classes } = this.props;

		const {
			//isE85,
			isDualFuelPickup,
			primaryProductType,
			firstTerminalProductType,
			secondTerminalProductType,
		} = this.stationDelivery;

		const primaryProductDisplay = valueToDisplay(primaryProductType);

		const station = leg.station;
		const amount = leg.deliveryAmount;
		const firstPickup = this.stationDelivery[fuelToPickupField('firstTerminal', leg.legNumber)];
		const secondPickup = this.stationDelivery[fuelToPickupField('secondTerminal', leg.legNumber)];

		let fuelLine;

		if (isDualFuelPickup) {
			fuelLine = (
				<div>
					<strong>{amount} E85 </strong>({secondPickup} {secondTerminalProductType} / {firstPickup}{' '}
					{firstTerminalProductType}) to:
				</div>
			);
		} else {
			fuelLine = (
				<div>
					<strong>
						{amount} {primaryProductDisplay}
					</strong>{' '}
					to:
				</div>
			);
		}

		const style = highlight
			? { border: '1px solid #ddd', backgroundColor: '#eef8ff', padding: 20 }
			: {};
		return (
			<div className={classes.inset} style={style}>
				{fuelLine}
				<div>
					{station.number} - {station.name}
				</div>
			</div>
		);
	};

	renderTerminal = ({ whichOne }) => {
		const { classes, supplierMap } = this.props;

		const {
			firstTerminalProductType,
			firstTerminalTerminal,
			firstTerminalSupplier,
			firstTerminalBackups,

			secondTerminalProductType,
			secondTerminalTerminal,
			secondTerminalSupplier,
			secondTerminalBackups,
		} = this.stationDelivery;

		let terminal, supplier, backups, productType;
		if (whichOne === 'first') {
			terminal = firstTerminalTerminal;
			supplier = firstTerminalSupplier;
			backups = firstTerminalBackups;
			productType = firstTerminalProductType;
		} else if (whichOne === 'second') {
			terminal = secondTerminalTerminal;
			supplier = secondTerminalSupplier;
			backups = secondTerminalBackups;
			productType = secondTerminalProductType;
		}

		const productTypeDisplay = valueToDisplay(productType);

		backups.forEach((backup) => {
			backup.supplier = supplierMap[backup.supplierId] || {
				name: `Missing supplier : ${backup.supplierId}`,
			};
		});

		return (
			<Fragment>
				<FMPSectionHeader label={`${productTypeDisplay} Pickup`} />
				<div className={classes.inset}>
					<div>{terminal.name}</div>

					<div style={{ paddingTop: 5 }}>
						<div>Use {supplier.name}</div>

						{backups.map((backup, i) => {
							return <div key={i}>If out use {backup.supplier.name}</div>;
						})}
					</div>
				</div>
			</Fragment>
		);
	};

	renderInvoiceFields = () => {
		const {
			classes,
			stations,
			carriers,
			stationDeliveryMap,
			stationInvoice,
			quickbooksTerms,
		} = this.props;
		const { products, invoiceDocuments, deliveryDate, carrierId } = this.state;

		//- Check if carrier matches the delivery
		let deliveryMatchSnippet = null;
		let deliveryDateMatchSnippet = null;
		let stationIsLocked = false;

		if (stationInvoice) {
			const { linkedStationDeliveryId } = stationInvoice;
			if (linkedStationDeliveryId) {
				//- If I have a linked station then the station on the order is locked
				stationIsLocked = true;

				const stationDelivery = stationDeliveryMap[linkedStationDeliveryId];
				if (stationDelivery) {
					const deliveryCarrierId = stationDelivery.carrierId;

					//
					//- See if the carrier matches documents and delivery
					//
					if (deliveryCarrierId === carrierId) {
						deliveryMatchSnippet = (
							<div className={classes.matchRow}>
								<CheckIcon className={classes.checkIcon} />
								<span>Carrier matches delivery.</span>
							</div>
						);
					} else {
						const carrier = _.find(carriers, {
							carrierId: deliveryCarrierId,
						}) || { name: `MISSING CARRIER: ${deliveryCarrierId}` };
						deliveryMatchSnippet = (
							<div className={classes.matchRow}>
								<WarningIcon className={classes.warningIcon} />
								<span>
									Carrier does not match delivery: <strong> {carrier.name}</strong>
								</span>
							</div>
						);
					}

					//
					//- See if the deliveryDate matches documents and delivery
					//
					let deliveryMoment = moment();
					//- Open the invoice at the beginning of the window
					if (stationDelivery.allDayWindow) {
						deliveryMoment = moment(stationDelivery.deliveryWindowStartDateTime);
					} else if (stationDelivery.deliveryWindowStartDateTime) {
						deliveryMoment = moment(stationDelivery.deliveryWindowStartDateTime);
					} else if (stationDelivery.deliveryWindowEndDateTime) {
						deliveryMoment = moment(stationDelivery.deliveryWindowEndDateTime);
					}

					if (deliveryMoment.format('YYYY-MM-DD') === deliveryDate) {
						deliveryDateMatchSnippet = (
							<div className={classes.matchRow}>
								<CheckIcon className={classes.checkIcon} />
								<span>Delivery date matches delivery.</span>
							</div>
						);
					} else {
						deliveryDateMatchSnippet = (
							<div className={classes.matchRow}>
								<WarningIcon className={classes.warningIcon} />
								<span>
									Delivery date does not match delivery:
									<strong> {deliveryMoment.format('M/D')}</strong>
								</span>
							</div>
						);
					}
				}
			}
		}

		//- Check if carrier matches document
		let documentCarrierId = 0;
		invoiceDocuments.forEach((invoiceDocument) => {
			const { documentType, data } = invoiceDocument;
			if (!data || documentType !== 'carrierDeliveryTicket') {
				return;
			}
			documentCarrierId = data.carrierId;
		});

		let documentMatchSnippet;
		if (documentCarrierId === carrierId) {
			documentMatchSnippet = (
				<div className={classes.matchRow}>
					<CheckIcon className={classes.checkIcon} />
					<span>Carrier matches delivery documents.</span>
				</div>
			);
		} else {
			const carrier = _.find(carriers, { carrierId: documentCarrierId }) || {
				name: `MISSING CARRIER: ${documentCarrierId}`,
			};
			documentMatchSnippet = (
				<div className={classes.matchRow}>
					<WarningIcon className={classes.warningIcon} />
					<span>
						Carrier does not match delivery documents: <strong>{carrier.name}</strong>
					</span>
				</div>
			);
		}

		let termOptions = [];
		quickbooksTerms.forEach((term) => {
			/** @namespace term.Id **/
			termOptions.push({ display: term.Name, value: term.Id });
		});

		return (
			<Fragment>
				<Grid container spacing={2}>
					<Grid item md={6} xs={12}>
						<FMPSectionHeader label={'Billing'} />

						<StationSelect
							path={['stationId']}
							controller={this}
							stations={stations}
							readOnly={stationIsLocked}
							helpText={
								stationIsLocked
									? 'Invoice is linked to station on delivery. Station can not be changed'
									: ''
							}
						/>

						<FMPDatePicker
							label="Issue Date"
							path={'issueDate'}
							onChange={this.onChange}
							value={this.getValue('issueDate')}
							error={this.getError('issueDate')}
						/>

						<FMPSelect
							label={`Terms`}
							path={['quickbooksTermId']}
							controller={this}
							options={termOptions}
						/>
					</Grid>
				</Grid>
				<Grid container spacing={2}>
					<Grid item md={6} xs={12}>
						<FMPSectionHeader label={'Carrier and Freight'} />

						<FMPCarrierSelect
							path={'carrierId'}
							onChange={this.onChange}
							value={this.getValue('carrierId')}
							error={this.getError('carrierId')}
							carriers={carriers}
						/>
						<div className={classes.matchContainer}>
							{deliveryMatchSnippet}
							{documentMatchSnippet}
						</div>

						<FMPText label={'Carrier PO Number'} path={['carrierPoNumber']} controller={this} />

						<FMPDatePicker
							label="Delivery Date"
							path={'deliveryDate'}
							onChange={this.onChange}
							value={this.getValue('deliveryDate')}
							error={this.getError('deliveryDate')}
						/>
						<div className={classes.matchContainer}>{deliveryDateMatchSnippet}</div>

						<FMPSectionHeader label={'Pricing'} />

						{this.renderPricing()}
					</Grid>
				</Grid>

				{products.map((product, index) => {
					return this.renderProduct({ product, index });
				})}

				<Grid container spacing={2}>
					<Grid item md={6} xs={12}>
						<FMPSectionHeader label={'Credits'} />

						<FMPText
							label={'Credit Amount'}
							path={['creditAmount']}
							controller={this}
							helpText={'Do not enter negative amounts. Amount will be subtracted from invoice'}
						/>

						<FMPText label={'Reason for credit'} path={['creditReason']} controller={this} />
					</Grid>
				</Grid>
			</Fragment>
		);
	};

	renderPricing = () => {
		const { stationInvoice } = this.props;

		const { productType } = stationInvoice;

		if (!productType) {
			return <div>!!! Missing productType on invoice</div>;
		}

		return (
			<Fragment>
				{productType === 'e85' ? this.renderE85Pricing() : this.renderOtherFuelPricing()}
				{this.renderManualPricing()}
			</Fragment>
		);
	};

	//- Manual pricing can only be set / changed / removed while the invoice is new or pending.
	//- Issued invoices go through Credit & Rebill.
	isManualPricingEditable = () => {
		const { stationInvoice } = this.props;
		const status = _.get(stationInvoice, ['status']);
		//- an invalidated invoice can already be in QB, where a new price would never land
		if (_.get(stationInvoice, ['quickbooksInvoiceId'])) {
			return false;
		}
		return !status || _.includes(MANUAL_PRICE_EDITABLE_STATUSES, status);
	};

	//- '$2.15', ' 2.15 ', '2.' all ok; rounded to 5 places like the backend. NaN when not a number.
	parseManualPrice = (value) => {
		const cleaned = _.trim(String(_.isNil(value) ? '' : value)).replace(/^\$/, '');
		if (!/^\d*\.?\d*$/.test(cleaned) || !/\d/.test(cleaned)) {
			return NaN;
		}
		return _.round(parseFloat(cleaned), 5);
	};

	//- Where the invoice's price comes from without manual pricing:
	//- 'calculated' (G&M / requireUnl), 'quote', or 'fuelCost' (non formula fuels, no quote)
	getPriceSource = () => {
		const { stationInvoice, stationMap, gasFormulaMap } = this.props;
		const { stationId, requireUnlPriceOnInvoicing } = this.state;
		const station = stationMap[stationId];
		if (!station) {
			return undefined;
		}
		const { productType } = stationInvoice;
		if (productType === 'e85') {
			const formulaKey = _.get(gasFormulaMap, [station.gasFormulaId, 'formulaKey']);
			return formulaKey === 'g&mE85' || requireUnlPriceOnInvoicing ? 'calculated' : 'quote';
		}
		if (station.biodieselFormulaId && _.includes(['b99', 'rd80/b20'], productType)) {
			return 'quote';
		}
		return 'fuelCost';
	};

	//- The price the invoice charges without manual pricing
	getSystemPrice = () => {
		const { calculatedWholesaleE85Price, fuelCostPerGallon } = this.state;
		const toPrice = (label, price) => {
			const n = parseFloat(price);
			return _.isFinite(n) ? { label, price: n } : undefined;
		};
		const priceSource = this.getPriceSource();
		if (priceSource === 'calculated') {
			return toPrice('Calculated', calculatedWholesaleE85Price);
		}
		if (priceSource === 'fuelCost') {
			return toPrice('Fuel cost', fuelCostPerGallon);
		}
		const selectedQuotedPrice = this.getSelectedQuotedPrice();
		return selectedQuotedPrice ? toPrice('Quoted', selectedQuotedPrice.price) : undefined;
	};

	handleUnlockManualPricing = () => {
		const newState = { isManualPricingUnlocked: true };
		//- Start from the price the invoice would otherwise charge, so a small fix is a small edit
		const systemPrice = this.getSystemPrice();
		if (_.isNil(this.state.manualPricePerGallon) && systemPrice) {
			newState.manualPricePerGallon = systemPrice.price;
		}
		this.setState(newState);
	};

	handleRevertManualPricing = () => {
		if (
			!window.confirm(
				'Turn off manual pricing? The manual price and reason will be removed when you save.'
			)
		) {
			return;
		}
		this.setState({
			isManualPricingUnlocked: false,
			manualPricePerGallon: undefined,
			manualPriceReason: undefined,
			formFieldError: _.omit(this.state.formFieldError, [
				'manualPricePerGallon',
				'manualPriceReason',
			]),
		});
	};

	getSelectedQuotedPrice = () => {
		const { stationQuotedPriceId, stationQuotedPrices } = this.state;
		if (!stationQuotedPriceId) {
			return undefined;
		}
		//- the refetched list only covers the current station/date; the map has older quotes
		return (
			_.find(stationQuotedPrices, { stationQuotedPriceId }) ||
			_.get(this.props.stationQuotedPriceMap, [stationQuotedPriceId])
		);
	};

	renderManualPricing = () => {
		const { classes, stationInvoice } = this.props;
		const { isManualPricingUnlocked, manualPricePerGallon } = this.state;
		const isEditable = this.isManualPricingEditable();

		//- Issued without a manual price: nothing to show, fixes go through Credit & Rebill
		if (!isEditable) {
			if (_.isNil(_.get(stationInvoice, ['manualPricePerGallon']))) {
				return null;
			}
			return (
				<ManualPriceNotice
					title={`Manual price: ${formatPricePerGallon(
						stationInvoice.manualPricePerGallon
					)} per gallon`}
				>
					<div>
						<b>Reason (internal only):</b> {stationInvoice.manualPriceReason}
					</div>
					<div style={{ color: '#666', marginTop: 5 }}>
						This invoice is already issued or in QuickBooks. Use Credit &amp; Rebill to correct the
						price.
					</div>
				</ManualPriceNotice>
			);
		}

		if (!isManualPricingUnlocked) {
			return (
				<div style={{ marginTop: 10 }}>
					<Button variant="outlined" color="primary" onClick={this.handleUnlockManualPricing}>
						Unlock manual pricing
					</Button>
				</div>
			);
		}

		const systemPrice = this.getSystemPrice();
		const manualPrice = this.parseManualPrice(manualPricePerGallon);
		let difference;
		if (systemPrice && _.isFinite(manualPrice)) {
			difference = _.round(manualPrice - systemPrice.price, 5);
		}

		const priceSource = this.getPriceSource();
		const isQuoteBased = priceSource !== 'fuelCost';

		return (
			<Fragment>
				<ManualPriceNotice title={'Manual pricing is on'}>
					{isQuoteBased ? (
						<Fragment>
							<div>
								The price you type below replaces the{' '}
								{priceSource === 'calculated' ? 'calculated' : 'quoted'} price on this invoice, its
								PDF and QuickBooks. Keep the correct quoted price selected above:
							</div>
							<ul className={classes.manualPriceList}>
								<li>
									Profit Report and Profit by Invoice: the freight is split out of the fuel amount
									using the quote&apos;s freight
								</li>
								<li>
									G&amp;M Monthly True Up: built from the quote&apos;s formula pieces and freight.
									The difference between the formula price and the manual price is added in its own
									Manual Price Adjustment column
								</li>
								<li>
									Credit &amp; Rebill: a rebill to the same customer starts with this quote and
									price
								</li>
								<li>
									Formula page: invoices that normally include a formula page won&apos;t get one,
									since a manual price isn&apos;t a formula
								</li>
							</ul>
						</Fragment>
					) : (
						<div>
							The price you type below replaces the fuel cost per gallon on this invoice, its PDF
							and QuickBooks. A rebill to the same customer starts with this price.
						</div>
					)}
				</ManualPriceNotice>

				<FMPText
					label={'Manual Price Per Gallon'}
					path={['manualPricePerGallon']}
					controller={this}
					helpText={`More than $${MANUAL_PRICE_MIN_EXCLUSIVE} and no more than $${MANUAL_PRICE_MAX}`}
				/>

				{systemPrice && (
					<div className={classes.manualPriceCompare}>
						{systemPrice.label} {formatPricePerGallon(systemPrice.price)}
						{' / '}Manual {formatPricePerGallon(manualPrice)}
						{!_.isNil(difference) && (
							<span>
								{' / '}Difference {difference > 0 ? '+' : ''}
								{formatPricePerGallon(difference)}
							</span>
						)}
					</div>
				)}

				<FMPText
					label={'Reason for manual price'}
					path={['manualPriceReason']}
					controller={this}
					multiline={2}
					helpText={'Required. Internal only, never shown to the customer.'}
				/>

				<div style={{ marginTop: 10 }}>
					<Button variant="outlined" onClick={this.handleRevertManualPricing}>
						{isQuoteBased ? 'Revert to quoted pricing' : 'Turn off manual pricing'}
					</Button>
				</div>
			</Fragment>
		);
	};

	renderE85Pricing = () => {
		const { stationMap, gasFormulaMap, classes } = this.props;
		const { stationId, requireUnlPriceOnInvoicing } = this.state;

		if (!stationId) {
			return <div>Choose a station first before you can choose pricing..</div>;
		}

		const station = stationMap[stationId];
		if (!station) {
			return <div>Station {stationId} not found? </div>;
		}

		const { gasFormulaId } = station;
		const gasFormula = gasFormulaMap[gasFormulaId];

		if (!gasFormula) {
			return <div>Gas Formula {gasFormulaId} not found? </div>;
		}

		const { formulaKey } = gasFormula;
		const isGm = formulaKey === 'g&mE85';
		const isFalcon = formulaKey === 'falconFormula';
		const isHs = formulaKey === 'h&sE85' || formulaKey === 'h&sNew';
		const is29Palms = formulaKey === '29Palms';

		if (isGm) {
			const { stationQuotedPrices } = this.state;
			return (
				<Fragment>
					<FMPStationQuotedPriceSelect
						label={'OPIS Data & Quoted E85 Price'}
						path={'stationQuotedPriceId'}
						onChange={this.onChange}
						value={this.getValue('stationQuotedPriceId')}
						error={this.getError('stationQuotedPriceId')}
						stationQuotedPrices={stationQuotedPrices}
						dataDumpMap={this.props.dataDumpMap}
						showUnleadedPrice={true}
						usePdiForUnlPrice={true}
					/>

					<div className={classes.infoBox}>
						<InfoIcon className={classes.infoIcon} />
						<span>
							After April 1st, G&M stations do not require freight inputted manually. Instead, the
							freight is automatically pulled from the price quoted for that day.
							<br />
							<br />
							This input is here for orders past before April 1st. If freight is entered it will
							override the quoted amount.
						</span>
					</div>

					<FMPText
						label={'Actual Total Freight Cost'}
						path={['actualTotalFreightCost']}
						controller={this}
					/>

					<FMPText
						label={'Actual Unleaded Fuel Cost Per Gallon'}
						path={['actualUnleadedFuelCostPerGallon']}
						controller={this}
					/>

					{this.renderCalculatedE85Formula()}
				</Fragment>
			);
		} else if (isFalcon || isHs) {
			const { stationQuotedPrices } = this.state;

			return (
				<Fragment>
					<FMPStationQuotedPriceSelect
						label={'Quoted E85 Price'}
						path={'stationQuotedPriceId'}
						onChange={this.onChange}
						value={this.getValue('stationQuotedPriceId')}
						error={this.getError('stationQuotedPriceId')}
						stationQuotedPrices={stationQuotedPrices}
					/>

					<FMPText
						label={'Actual Total Freight Cost'}
						path={['actualTotalFreightCost']}
						controller={this}
						helpText={'Does not get blended into E85 Price. Will show up as line item on invoice.'}
					/>

					{this.renderCalculatedE85Formula()}
				</Fragment>
			);
		} else if (is29Palms) {
			const { stationQuotedPrices } = this.state;

			return (
				<Fragment>
					<FMPStationQuotedPriceSelect
						label={'Quoted E85 Price'}
						path={'stationQuotedPriceId'}
						onChange={this.onChange}
						value={this.getValue('stationQuotedPriceId')}
						error={this.getError('stationQuotedPriceId')}
						stationQuotedPrices={stationQuotedPrices}
					/>

					<FMPText
						label={'Actual Total Freight Cost'}
						path={['actualTotalFreightCost']}
						controller={this}
					/>

					{this.renderCalculatedE85Formula()}
				</Fragment>
			);
		} else if (requireUnlPriceOnInvoicing) {
			const { stationQuotedPrices } = this.state;

			return (
				<Fragment>
					<div className={classes.infoBox}>
						<InfoIcon className={classes.infoIcon} />
						<span>Station is marked as requiring unleaded pricing on invoicing.</span>
					</div>

					<FMPStationQuotedPriceSelect
						label={'OPIS Data & Quoted E85 Price'}
						path={'stationQuotedPriceId'}
						onChange={this.onChange}
						value={this.getValue('stationQuotedPriceId')}
						error={this.getError('stationQuotedPriceId')}
						stationQuotedPrices={stationQuotedPrices}
						dataDumpMap={this.props.dataDumpMap}
						showUnleadedPrice={true}
					/>

					<FMPText
						label={'Actual Unleaded Fuel Cost Per Gallon'}
						path={['actualUnleadedFuelCostPerGallon']}
						controller={this}
					/>

					{/*
				<FMPText
					label={'Actual Total Freight Cost'}
					path={['actualTotalFreightCost']}
					controller={this}
				/>
				*/}

					{this.renderCalculatedE85Formula()}
				</Fragment>
			);
		} else {
			const { stationQuotedPrices } = this.state;
			return (
				<FMPStationQuotedPriceSelect
					label={'Quoted E85 Price'}
					path={'stationQuotedPriceId'}
					onChange={this.onChange}
					value={this.getValue('stationQuotedPriceId')}
					error={this.getError('stationQuotedPriceId')}
					stationQuotedPrices={stationQuotedPrices}
				/>
			);
		}
	};

	renderOtherFuelPricing = () => {
		const { stationInvoice, stationMap } = this.props;
		const { stationId } = this.state;

		if (!stationId) {
			return <div>Choose a station first before you can choose pricing..</div>;
		}

		const station = stationMap[stationId];
		if (!station) {
			return <div>Station {stationId} not found? </div>;
		}

		const { productType } = stationInvoice;
		const { biodieselFormulaId } = station;

		const isBdWithFormula = biodieselFormulaId && productType === 'b99';
		const isRd80 = biodieselFormulaId && productType === 'rd80/b20';

		if (isRd80) {
			const { stationQuotedPrices } = this.state;
			return (
				<Fragment>
					<FMPStationQuotedPriceSelect
						label={'Quoted RD80/B20 Price'}
						path={'stationQuotedPriceId'}
						onChange={this.onChange}
						value={this.getValue('stationQuotedPriceId')}
						error={this.getError('stationQuotedPriceId')}
						stationQuotedPrices={stationQuotedPrices}
					/>
				</Fragment>
			);
		} else if (isBdWithFormula) {
			const { stationQuotedPrices } = this.state;
			return (
				<Fragment>
					<FMPStationQuotedPriceSelect
						label={'Quoted Biodiesel Price'}
						path={'stationQuotedPriceId'}
						onChange={this.onChange}
						value={this.getValue('stationQuotedPriceId')}
						error={this.getError('stationQuotedPriceId')}
						stationQuotedPrices={stationQuotedPrices}
					/>
					<FMPText
						label={'Total Freight Cost (optional)'}
						path={['actualTotalFreightCost']}
						controller={this}
					/>
				</Fragment>
			);
		} else {
			return (
				<Fragment>
					<FMPText label={'Fuel Cost Per Gallon'} path={['fuelCostPerGallon']} controller={this} />
					<FMPText
						label={'Total Freight Cost (optional)'}
						path={['actualTotalFreightCost']}
						controller={this}
					/>
				</Fragment>
			);
		}
	};

	renderCalculatedE85Formula = () => {
		//const { } = this.props;
		const {
			hideFormulaReason,
			formulaRows,
			formulaNotes = [],
			isManualPricingUnlocked,
		} = this.state;

		if (hideFormulaReason) {
			return <div>{hideFormulaReason}</div>;
		}

		//- Greyed out while manual pricing is on: it is not the price being charged
		if (isManualPricingUnlocked) {
			return (
				<div style={{ opacity: 0.45 }}>
					<div style={{ color: '#999', marginTop: 10 }}>
						Formula price (not used, manual pricing is on)
					</div>
					<Formula formulaRows={formulaRows} formulaNotes={formulaNotes} />
				</div>
			);
		}

		return <Formula formulaRows={formulaRows} formulaNotes={formulaNotes} />;
	};

	//- Get
	getDataAndPricing = () => {
		const { stationQuotedPriceMap, dataDumpMap } = this.props;
		const { stationQuotedPriceId } = this.state;

		const ret = {
			data: undefined,
			hideFormulaReason: undefined,
			stationQuotedPrice: undefined,
		};

		if (!stationQuotedPriceId) {
			ret.hideFormulaReason = 'Select quoted price...';
			return ret;
		}

		//const stationQuotedPriceMap = _.keyBy(stationQuotedPrices, 'stationQuotedPriceId');
		const stationQuotedPrice = stationQuotedPriceMap[stationQuotedPriceId];

		if (!stationQuotedPrice) {
			ret.hideFormulaReason = 'Could not find station quoted price in map';
			return ret;
		}
		ret.stationQuotedPrice = stationQuotedPrice;

		const { dataDumpId } = stationQuotedPrice;

		if (!dataDumpId) {
			ret.hideFormulaReason =
				'Quoted price missing the data dump. This estimate cant be used. Sorry.';
			return ret;
		}

		const dataDump = dataDumpMap[dataDumpId];
		if (!dataDump) {
			ret.hideFormulaReason = 'Could not get data from dataDumpMap';
			return ret;
		}

		ret.data = dataDump.data;
		return ret;
	};

	renderProduct = ({ product, index }) => {
		const {
			terminals,
			stationDeliveryMap,
			terminalMap,
			supplierMap,
			classes,
			stationInvoice,
		} = this.props;
		const { invoiceDocuments } = this.state;
		const { productType, bolNumbers, netGallons, terminalSupplier } = product;

		let terminalId, supplierId;
		if (terminalSupplier) {
			({ terminalId, supplierId } = terminalSupplier);
		}
		const productTypeDisplay = valueToDisplay(productType);

		//- Check if gallons match within 5% of the delivery
		//- Do this by checking if the stationId is the primary / secondary.
		//- Then get the amounts
		let deliveryMatchSnippet = null;
		let deliveryTerminalMatchSnippet = null;
		let deliverySupplierMatchSnippet = null;

		const matchResult = matchProductToDelivery({
			stationDeliveryMap,
			stationInvoice,
			productType,
			netGallons: parseInt(netGallons, 10),
			terminalId,
			supplierId,
			terminalMap,
			supplierMap,
		});

		if (matchResult.matched) {
			deliveryMatchSnippet = (
				<div className={classes.matchRow}>
					<CheckIcon className={classes.checkIcon} />
					<span>
						Net gallons match amounts on delivery within{' '}
						{NET_GALLONS_DELIVERY_MATCH_THRESHOLD * 100}%.
					</span>
				</div>
			);
		} else if (!_.isEmpty(matchResult.reasonsForNotMatching)) {
			const reasons = matchResult.reasonsForNotMatching;

			deliveryMatchSnippet = (
				<div className={classes.matchRow}>
					<WarningIcon className={classes.warningIcon} />
					<div>
						{reasons.map((reason, i) => {
							return <div key={i}>- {reason}</div>;
						})}
					</div>
				</div>
			);
		}

		if (matchResult.reasonForTerminalNotMatching) {
			deliveryTerminalMatchSnippet = (
				<div className={classes.matchRow}>
					<WarningIcon className={classes.warningIcon} />
					{matchResult.reasonForTerminalNotMatching}
				</div>
			);
		} else if (matchResult.terminalsMatch) {
			deliveryTerminalMatchSnippet = (
				<div className={classes.matchRow}>
					<CheckIcon className={classes.checkIcon} />
					<span>Delivery terminal matches invoice terminal.</span>
				</div>
			);
		}

		if (matchResult.reasonForSupplierNotMatching) {
			deliverySupplierMatchSnippet = (
				<div className={classes.matchRow}>
					<WarningIcon className={classes.warningIcon} />
					{matchResult.reasonForSupplierNotMatching}
					<div></div>
				</div>
			);
		} else if (matchResult.suppliersMatch) {
			deliverySupplierMatchSnippet = (
				<div className={classes.matchRow}>
					<CheckIcon className={classes.checkIcon} />
					<span>Delivery supplier matches invoice supplier.</span>
				</div>
			);
		}

		//
		//- Calc what the delivery document thinks what is saved
		//
		let documentNetGallons = 0;
		const documentReasons = [];
		invoiceDocuments.forEach((invoiceDocument) => {
			const { data } = invoiceDocument;
			if (!data || data.productType !== productType) {
				return;
			}
			const { netGallons } = data;
			documentNetGallons += parseInt(netGallons, 10);
			documentReasons.push(`${invoiceDocument.name} has stated ${netGallons} gallons`);
		});

		let documentMatchSnippet;
		if (documentNetGallons === parseInt(product.netGallons, 10)) {
			documentMatchSnippet = (
				<div className={classes.matchRow}>
					<CheckIcon className={classes.checkIcon} />
					<span>Net gallons match amounts in delivery documents.</span>
				</div>
			);
		} else {
			documentReasons.unshift(
				`Net gallons do not match amounts in delivery documents : ${documentNetGallons}`
			);
			documentMatchSnippet = (
				<div className={classes.matchRow}>
					<WarningIcon className={classes.warningIcon} />
					<div>
						{documentReasons.map((reason, i) => {
							return <div key={i}>- {reason}</div>;
						})}
					</div>
				</div>
			);
		}

		const path = `products.${index}.terminalSupplier`;
		const val = _.get(this.state, path, DEFAULT_TERMINAL_SUPPLIER_VALUE);

		return (
			<Grid container spacing={2} key={index}>
				<Grid item md={6} xs={12}>
					<FMPSectionHeader label={`${productTypeDisplay} Info`} />

					<FMPTerminalSupplierSelect
						label={`${productTypeDisplay} Terminal`}
						supplierLabel={`${productTypeDisplay} Supplier`}
						terminalId={val.terminalId}
						supplierId={val.supplierId}
						path={path}
						onChange={this.onTerminalSupplierChange}
						error={this.getError(path)}
						supplierError={this.getError(path)}
						terminals={terminals}
						supplierMap={supplierMap}
						productTypes={[productType]}
						md={12}
					/>

					{!!deliveryTerminalMatchSnippet && (
						<div className={classes.matchContainer}>{deliveryTerminalMatchSnippet}</div>
					)}
					{!!deliverySupplierMatchSnippet && (
						<div className={classes.matchContainer}>{deliverySupplierMatchSnippet}</div>
					)}

					{!_.isEmpty(bolNumbers) &&
						bolNumbers.map((bolNumber, bolIndex) => {
							const bolCount = bolNumbers.length === 1 ? '' : ` #${bolIndex + 1}`;
							return (
								<FMPText
									key={bolIndex}
									label={`BOL Number${bolCount}`}
									path={['products', index, 'bolNumbers', bolIndex]}
									controller={this}
								/>
							);
						})}

					<FMPText
						label={'Net Gallons'}
						path={['products', index, 'netGallons']}
						controller={this}
					/>

					<div className={classes.matchContainer}>
						{deliveryMatchSnippet}
						{documentMatchSnippet}
					</div>
				</Grid>
			</Grid>
		);
	};
}

SaveStationInvoice.propTypes = {
	authUser: PropTypes.object,
	getStationInvoice: PropTypes.func.isRequired,
	quickbooksCustomerMap: PropTypes.object,
	stationInvoice: PropTypes.object,
	stationDeliveryMap: PropTypes.object,
	stationMap: PropTypes.object,
	gasFormulaMap: PropTypes.object,
	biodieselFormulaMap: PropTypes.object,
	rackFormulaMap: PropTypes.object,
	invoiceDocumentMap: PropTypes.object,
	resourceMap: PropTypes.object,

	addStationInvoice: PropTypes.func.isRequired,
	updateStationInvoice: PropTypes.func.isRequired,
	invalidateStationInvoice: PropTypes.func.isRequired,

	searchStations: PropTypes.func.isRequired,
	stations: PropTypes.array,

	searchCarriers: PropTypes.func.isRequired,
	carriers: PropTypes.array,

	searchTerminals: PropTypes.func.isRequired,
	terminals: PropTypes.array,
	terminalMap: PropTypes.object,
	supplierMap: PropTypes.object,

	searchQuickbooksTerms: PropTypes.func.isRequired,
	quickbooksTerms: PropTypes.array,

	convertToPages: PropTypes.func,

	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,

	searchStationQuotedPrices: PropTypes.func.isRequired,
	stationQuotedPriceMap: PropTypes.object,

	dataDumpMap: PropTypes.object,
	//- latest data is used for G&M

	//- credit & rebill
	getInvoiceCreditMemo: PropTypes.func,
	canCreditRebillInvoices: PropTypes.bool,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	StationInvoiceContainer,
	StationsContainer,
	CarriersContainer,
	TerminalsContainer,
	DocumentContainer,
	QuickbooksContainer,
	StationQuotedPriceContainer,
	DataDumpContainer,
	InvoiceCreditMemoContainer,
	AuthUserContainer,
])(SaveStationInvoice);
